export const listSVGIcon02 = {
  "process-group-green": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path d="M20 6H10V8H20V6Z" fill="#39d762" />
        <path
          d="M2.26668 21.1875V2.81249C2.26668 2.29554 2.77506 1.87499 3.39998 1.87499H19.6001C20.225 1.87499 20.7334 2.29554 20.7334 2.81249V10.0683L23 12V2.81249C23 1.26168 21.4748 0 19.6001 0H3.39998C1.52526 0 0 1.26168 0 2.81249V21.1875C0 22.7383 1.5252 24 3.39993 24H10L10.5 22.125H3.39998C2.77506 22.125 2.26668 21.7045 2.26668 21.1875Z"
          fill="#39d762"
        />
        <path d="M20 11H10V13H18L20 11Z" fill="#39d762" />
        <path
          d="M20.117 12L13.8232 18.4717C13.4635 18.8328 13.1888 19.2791 13.0285 19.7629L13.0143 19.8058L12 24L16.4723 23.265L16.5165 23.2503C17.0027 23.0894 17.4512 22.8131 17.8134 22.451L24.1063 15.9804L20.117 12ZM16.4851 21.1301C16.45 21.1648 16.413 21.1976 16.3745 21.2284L15.0515 19.9045C15.0832 19.8651 15.117 19.8273 15.1527 19.7916L20.137 14.6665L21.4738 16.0003L16.4851 21.1301Z"
          fill="#39d762"
        />
        <path
          d="M8.48433 9.40326L6.19176 12.0036L5.05096 10.9323L3.76855 12.298L6.31856 14.6926L9.8896 10.6423L8.48433 9.40326Z"
          fill="#39d762"
        />
        <path
          d="M8.48433 3.73624L6.19176 6.33654L5.05096 5.26526L3.76855 6.63097L6.31856 9.02554L9.8896 4.97519L8.48433 3.73624Z"
          fill="#39d762"
        />
        <path
          d="M5.05096 16.5526L3.76855 17.9183L6.31856 20.3129L9.8896 16.2626L8.48433 15.0236L6.19176 17.6239L5.05096 16.5526Z"
          fill="#39d762"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "check-box-learn": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#00C590" />
      <path d="M6 15L12.5 21L23 10" stroke="white" strokeWidth="3" />
    </svg>
  ),
  share_cv: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
      style={{ fill: "#fff" }}
    >
      <path d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z" />
    </svg>
  ),
  "eye-slash-cv": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 640 512"
      style={{ fill: "#fff" }}
    >
      <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
    </svg>
  ),
  eye_cv: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 576 512"
      style={{ fill: "#fff" }}
    >
      <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
    </svg>
  ),
  download_cv: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
      style={{ fill: "#fff" }}
    >
      <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
    </svg>
  ),
  edit_cv: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
      style={{ fill: "#fff" }}
    >
      <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
    </svg>
  ),
  "floppy-disk": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1.5em"
      viewBox="0 0 448 512"
    >
      <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
    </svg>
  ),
  "chart-line": (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
      <path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z" />
    </svg>
  ),
  student: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z" />
    </svg>
  ),
  paper: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512">
      <path d="M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z" />
    </svg>
  ),
  language: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z" />
    </svg>
  ),
  coder: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512">
      <path d="M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z" />
    </svg>
  ),
  trophy: (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512">
      <path d="M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z" />
    </svg>
  ),
  "notice-partner-white": (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4043 7H13.4043V9H11.4043V7ZM11.4043 11H13.4043V17H11.4043V11ZM12.4043 2C6.8843 2 2.4043 6.48 2.4043 12C2.4043 17.52 6.8843 22 12.4043 22C17.9243 22 22.4043 17.52 22.4043 12C22.4043 6.48 17.9243 2 12.4043 2ZM12.4043 20C7.9943 20 4.4043 16.41 4.4043 12C4.4043 7.59 7.9943 4 12.4043 4C16.8143 4 20.4043 7.59 20.4043 12C20.4043 16.41 16.8143 20 12.4043 20Z"
        fill="#fff"
      />
    </svg>
  ),
  "play-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z"
        fill="#666"
        fillOpacity="0.54"
      />
    </svg>
  ),
  group: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
        fill="#666"
        fillOpacity="0.54"
      />
    </svg>
  ),
  config: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#4d4d4d"
      />
    </svg>
  ),
  usd: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="26"
      height="26"
      viewBox="0 0 172 172"
    >
      <g
        fill="none"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
        textAnchor="none"
      >
        <path d="M0,172v-172h172v172z" fill="none"></path>
        <g fill="#1fb141">
          <path d="M21.5,21.5v129h64.5v-32.25v-64.5v-32.25zM86,53.75c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25c-17.7805,0 -32.25,14.4695 -32.25,32.25zM118.25,86c-17.7805,0 -32.25,14.4695 -32.25,32.25c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25z"></path>
        </g>
      </g>
    </svg>
  ),
  "linked-in": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40"
      height="40"
      viewBox="0 0 64 64"
    >
      <radialGradient
        id="jAVUMfCM1liBjYZwQpghOa"
        cx="32"
        cy="31.5"
        r="31.259"
        gradientUnits="userSpaceOnUse"
        spreadMethod="reflect"
      >
        <stop offset="0" stopColor="#c5f1ff"></stop>
        <stop offset=".35" stopColor="#cdf3ff"></stop>
        <stop offset=".907" stopColor="#e4faff"></stop>
        <stop offset="1" stopColor="#e9fbff"></stop>
      </radialGradient>
      <path
        fill="url(#undefined)"
        d="M58,54c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2h2.5c1.925,0,3.5-1.575,3.5-3.5 S62.425,43,60.5,43H50c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h8c1.65,0,3-1.35,3-3c0-1.65-1.35-3-3-3H42v-6h18 c2.335,0,4.22-2.028,3.979-4.41C63.77,19.514,61.897,18,59.811,18H58c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2h0.357 c1.308,0,2.499-0.941,2.63-2.242C61.137,10.261,59.966,9,58.5,9h-14C43.672,9,43,8.328,43,7.5S43.672,6,44.5,6h3.857 c1.308,0,2.499-0.941,2.63-2.242C51.137,2.261,49.966,1,48.5,1L15.643,1c-1.308,0-2.499,0.941-2.63,2.242 C12.863,4.739,14.034,6,15.5,6H19c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2H6.189c-2.086,0-3.958,1.514-4.168,3.59 C1.78,15.972,3.665,18,6,18h2.5c1.933,0,3.5,1.567,3.5,3.5c0,1.933-1.567,3.5-3.5,3.5H5.189c-2.086,0-3.958,1.514-4.168,3.59 C0.78,30.972,2.665,33,5,33h17v11H6c-1.65,0-3,1.35-3,3c0,1.65,1.35,3,3,3h0c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2H4.189 c-2.086,0-3.958,1.514-4.168,3.59C-0.22,59.972,1.665,62,4,62h53.811c2.086,0,3.958-1.514,4.168-3.59C62.22,56.028,60.335,54,58,54z"
      ></path>
      <linearGradient
        id="jAVUMfCM1liBjYZwQpghOb_118979_gr1"
        x1="32"
        x2="32"
        y1="59.381"
        y2="15.381"
        gradientUnits="userSpaceOnUse"
        spreadMethod="reflect"
      >
        <stop offset="0" stopColor="#155cde"></stop>
        <stop offset=".278" stopColor="#1f7fe5"></stop>
        <stop offset=".569" stopColor="#279ceb"></stop>
        <stop offset=".82" stopColor="#2cafef"></stop>
        <stop offset="1" stopColor="#2eb5f0"></stop>
      </linearGradient>
      <path
        fill="url(#jAVUMfCM1liBjYZwQpghOb_118979_gr1)"
        d="M50,12H14c-2.209,0-4,1.791-4,4v36c0,2.209,1.791,4,4,4h36c2.209,0,4-1.791,4-4V16 C54,13.791,52.209,12,50,12z"
      ></path>
      <path
        fill="#fff"
        d="M19 28h2c1.105 0 2 .895 2 2v17c0 1.105-.895 2-2 2h-2c-1.105 0-2-.895-2-2V30C17 28.895 17.895 28 19 28zM19.981 25h-.033C18.158 25 17 23.664 17 22c0-1.706 1.195-3 3.019-3 1.823 0 2.948 1.294 2.981 3C23 23.664 21.842 25 19.981 25zM45 49h-2c-1.105 0-2-.895-2-2v-9.372c0-2.749-1.506-4.624-4.239-4.624-1.953 0-3.133 1.265-3.626 2.485C32.954 35.929 33 37.14 33 37.75V47c0 1.105-.888 2-1.993 2H29c-1.105 0-2-.895-2-2V30c0-1.105.895-2 2-2h2.007c1.105 0 2 .895 2 2v1.021C33.911 29.625 35.564 28 39.173 28 43.646 28 47 30.563 47 36.842V47C47 48.105 46.105 49 45 49z"
      ></path>
    </svg>
  ),
  view: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
        stroke="#777777"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
        stroke="#777777"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bell: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39144 8.12495C4.3904 7.38371 4.53609 6.64959 4.8201 5.96491C5.1041 5.28024 5.52082 4.65854 6.04621 4.13567C6.57161 3.61279 7.19531 3.19907 7.88134 2.91837C8.56738 2.63766 9.30219 2.49551 10.0434 2.50011C13.1364 2.5231 15.6103 5.09396 15.6103 8.19557V8.74995C15.6103 11.548 16.1957 13.1717 16.7113 14.0592C16.7669 14.154 16.7964 14.2618 16.797 14.3717C16.7976 14.4816 16.7692 14.5897 16.7147 14.6851C16.6602 14.7805 16.5814 14.8599 16.4865 14.9151C16.3915 14.9704 16.2836 14.9997 16.1737 15H3.82742C3.71752 14.9997 3.60963 14.9704 3.51464 14.9151C3.41966 14.8598 3.34093 14.7805 3.28641 14.685C3.23189 14.5896 3.2035 14.4815 3.20411 14.3716C3.20472 14.2617 3.2343 14.1539 3.28987 14.059C3.80575 13.1716 4.39143 11.5479 4.39143 8.74995L4.39144 8.12495Z"
        stroke="#595959"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15V15.625C7.5 16.288 7.76339 16.9239 8.23223 17.3928C8.70107 17.8616 9.33696 18.125 10 18.125C10.663 18.125 11.2989 17.8616 11.7678 17.3928C12.2366 16.9239 12.5 16.288 12.5 15.625V15"
        stroke="#595959"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "search-slide": (
    <svg
      width="180"
      height="183"
      viewBox="0 0 180 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9239 98.6019L45.1697 45.1768C46.1442 42.4717 48.4952 40.4977 51.3281 40.006L107.346 30.2825C110.155 29.795 113.011 30.8387 114.843 33.0224L152.1 77.4234C153.932 79.6068 154.464 82.6002 153.496 85.2812L134.2 138.754C133.224 141.458 130.872 143.431 128.038 143.921L72.0758 153.603C69.2686 154.089 66.415 153.045 64.5837 150.862L27.3221 106.456C25.491 104.273 24.9584 101.282 25.9239 98.6019Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M87.6562 106.062C96.7172 106.062 104.062 98.7172 104.062 89.6562C104.062 80.5953 96.7172 73.25 87.6562 73.25C78.5953 73.25 71.25 80.5953 71.25 89.6562C71.25 98.7172 78.5953 106.062 87.6562 106.062Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.2559 101.258L108.748 110.75"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "teacher-orange": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M15 15.0026C16.8417 15.0026 18.3333 13.5109 18.3333 11.6693C18.3333 9.8276 16.8417 8.33594 15 8.33594C13.1583 8.33594 11.6667 9.8276 11.6667 11.6693C11.6667 13.5109 13.1583 15.0026 15 15.0026ZM15 16.6693C12.775 16.6693 8.33334 17.7859 8.33334 20.0026V20.8359C8.33334 21.2943 8.70834 21.6693 9.16668 21.6693H20.8333C21.2917 21.6693 21.6667 21.2943 21.6667 20.8359V20.0026C21.6667 17.7859 17.225 16.6693 15 16.6693Z"
        fill="white"
      />
    </svg>
  ),
  "book-orange": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M22.5 9.16667C21.575 8.875 20.5583 8.75 19.5833 8.75C17.9583 8.75 16.2083 9.08333 15 10C13.7917 9.08333 12.0417 8.75 10.4167 8.75C8.79168 8.75 7.04168 9.08333 5.83334 10V22.2083C5.83334 22.4167 6.04168 22.625 6.25001 22.625C6.33334 22.625 6.37501 22.5833 6.45834 22.5833C7.58334 22.0417 9.20834 21.6667 10.4167 21.6667C12.0417 21.6667 13.7917 22 15 22.9167C16.125 22.2083 18.1667 21.6667 19.5833 21.6667C20.9583 21.6667 22.375 21.9167 23.5417 22.5417C23.625 22.5833 23.6667 22.5833 23.75 22.5833C23.9583 22.5833 24.1667 22.375 24.1667 22.1667V10C23.6667 9.625 23.125 9.375 22.5 9.16667ZM22.5 20.4167C21.5833 20.125 20.5833 20 19.5833 20C18.1667 20 16.125 20.5417 15 21.25V11.6667C16.125 10.9583 18.1667 10.4167 19.5833 10.4167C20.5833 10.4167 21.5833 10.5417 22.5 10.8333V20.4167Z"
        fill="white"
      />
      <path
        d="M19.5833 13.75C20.3167 13.75 21.025 13.825 21.6667 13.9667V12.7C21.0083 12.575 20.3 12.5 19.5833 12.5C18.1667 12.5 16.8833 12.7417 15.8333 13.1917V14.575C16.775 14.0417 18.0833 13.75 19.5833 13.75Z"
        fill="white"
      />
      <path
        d="M15.8333 15.4104V16.7937C16.775 16.2604 18.0833 15.9688 19.5833 15.9688C20.3167 15.9688 21.025 16.0438 21.6667 16.1854V14.9187C21.0083 14.7937 20.3 14.7188 19.5833 14.7188C18.1667 14.7188 16.8833 14.9687 15.8333 15.4104Z"
        fill="white"
      />
      <path
        d="M19.5833 16.9453C18.1667 16.9453 16.8833 17.187 15.8333 17.637V19.0203C16.775 18.487 18.0833 18.1953 19.5833 18.1953C20.3167 18.1953 21.025 18.2703 21.6667 18.412V17.1453C21.0083 17.012 20.3 16.9453 19.5833 16.9453Z"
        fill="white"
      />
    </svg>
  ),
  "student-orange": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M18.75 14.9974C19.9 14.9974 20.825 14.0641 20.825 12.9141C20.825 11.7641 19.9 10.8307 18.75 10.8307C17.6 10.8307 16.6667 11.7641 16.6667 12.9141C16.6667 14.0641 17.6 14.9974 18.75 14.9974ZM12.5 14.1641C13.8833 14.1641 14.9917 13.0474 14.9917 11.6641C14.9917 10.2807 13.8833 9.16406 12.5 9.16406C11.1167 9.16406 9.99999 10.2807 9.99999 11.6641C9.99999 13.0474 11.1167 14.1641 12.5 14.1641ZM18.75 16.6641C17.225 16.6641 14.1667 17.4307 14.1667 18.9557V19.9974C14.1667 20.4557 14.5417 20.8307 15 20.8307H22.5C22.9583 20.8307 23.3333 20.4557 23.3333 19.9974V18.9557C23.3333 17.4307 20.275 16.6641 18.75 16.6641ZM12.5 15.8307C10.5583 15.8307 6.66666 16.8057 6.66666 18.7474V19.9974C6.66666 20.4557 7.04166 20.8307 7.49999 20.8307H12.5V18.9557C12.5 18.2474 12.775 17.0057 14.475 16.0641C13.75 15.9141 13.05 15.8307 12.5 15.8307Z"
        fill="white"
      />
    </svg>
  ),
  "register-orange": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M17.5 15.0026C19.3417 15.0026 20.8333 13.5109 20.8333 11.6693C20.8333 9.8276 19.3417 8.33594 17.5 8.33594C15.6583 8.33594 14.1667 9.8276 14.1667 11.6693C14.1667 13.5109 15.6583 15.0026 17.5 15.0026ZM10 13.3359V11.6693C10 11.2109 9.62501 10.8359 9.16668 10.8359C8.70834 10.8359 8.33334 11.2109 8.33334 11.6693V13.3359H6.66668C6.20834 13.3359 5.83334 13.7109 5.83334 14.1693C5.83334 14.6276 6.20834 15.0026 6.66668 15.0026H8.33334V16.6693C8.33334 17.1276 8.70834 17.5026 9.16668 17.5026C9.62501 17.5026 10 17.1276 10 16.6693V15.0026H11.6667C12.125 15.0026 12.5 14.6276 12.5 14.1693C12.5 13.7109 12.125 13.3359 11.6667 13.3359H10ZM17.5 16.6693C15.275 16.6693 10.8333 17.7859 10.8333 20.0026V20.8359C10.8333 21.2943 11.2083 21.6693 11.6667 21.6693H23.3333C23.7917 21.6693 24.1667 21.2943 24.1667 20.8359V20.0026C24.1667 17.7859 19.725 16.6693 17.5 16.6693Z"
        fill="white"
      />
    </svg>
  ),
  "date-orange": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M20.8333 8.33073H20V7.4974C20 7.03906 19.625 6.66406 19.1667 6.66406C18.7083 6.66406 18.3333 7.03906 18.3333 7.4974V8.33073H11.6667V7.4974C11.6667 7.03906 11.2917 6.66406 10.8333 6.66406C10.375 6.66406 10 7.03906 10 7.4974V8.33073H9.16667C8.24167 8.33073 7.50833 9.08073 7.50833 9.9974L7.5 21.6641C7.5 22.5807 8.24167 23.3307 9.16667 23.3307H20.8333C21.75 23.3307 22.5 22.5807 22.5 21.6641V9.9974C22.5 9.08073 21.75 8.33073 20.8333 8.33073ZM20.8333 20.8307C20.8333 21.2891 20.4583 21.6641 20 21.6641H10C9.54167 21.6641 9.16667 21.2891 9.16667 20.8307V12.4974H20.8333V20.8307ZM10.8333 14.1641H12.5V15.8307H10.8333V14.1641ZM14.1667 14.1641H15.8333V15.8307H14.1667V14.1641ZM17.5 14.1641H19.1667V15.8307H17.5V14.1641Z"
        fill="white"
      />
    </svg>
  ),
  "check-blu": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.14644 13.8282L7.49981 14.1815L7.85337 13.8283L16.0867 5.60334L16.0869 5.60316C16.2166 5.47342 16.425 5.47342 16.5548 5.60316C16.6845 5.7329 16.6845 5.94132 16.5548 6.07106L7.73811 14.8877C7.60837 15.0175 7.39995 15.0175 7.27021 14.8877L3.78688 11.4044C3.65714 11.2747 3.65714 11.0662 3.78688 10.9365C3.91662 10.8068 4.12503 10.8068 4.25477 10.9365L7.14644 13.8282Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  activity: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38056 2.50136C8.74477 2.5221 9.05315 2.77732 9.14162 3.13123L11.8259 13.8683L13.3862 9.70741C13.5082 9.38215 13.8191 9.16668 14.1665 9.16668H17.4998C17.9601 9.16668 18.3332 9.53977 18.3332 10C18.3332 10.4602 17.9601 10.8333 17.4998 10.8333H14.744L12.4468 16.9593C12.3187 17.3009 11.9833 17.5194 11.6191 17.4987C11.2549 17.4779 10.9465 17.2227 10.8581 16.8688L8.17378 6.13171L6.61345 10.2926C6.49148 10.6179 6.18054 10.8333 5.83317 10.8333H2.49984C2.0396 10.8333 1.6665 10.4602 1.6665 10C1.6665 9.53977 2.0396 9.16668 2.49984 9.16668H5.25567L7.5529 3.04074C7.68099 2.69917 8.01635 2.48061 8.38056 2.50136Z"
        fill="#154398"
      />
    </svg>
  ),
  "reply-right": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 7.50152V6.17652C11.6667 5.43485 12.5667 5.05985 13.0917 5.58485L16.9167 9.40985C17.2417 9.73485 17.2417 10.2599 16.9167 10.5849L13.0917 14.4099C12.5667 14.9349 11.6667 14.5682 11.6667 13.8265V12.4182C7.49998 12.4182 4.58332 13.7515 2.49998 16.6682C3.33332 12.5015 5.83332 8.33485 11.6667 7.50152Z"
        fill="#F88C00"
      />
    </svg>
  ),
  "mode-comment": (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3335 11.9454L12.5535 11.1654H2.66683V3.16536H13.3335V11.9454ZM13.3335 1.83203H2.66683C1.9335 1.83203 1.3335 2.43203 1.3335 3.16536V11.1654C1.3335 11.8987 1.9335 12.4987 2.66683 12.4987H12.0002L14.6668 15.1654V3.16536C14.6668 2.43203 14.0668 1.83203 13.3335 1.83203Z"
        fill="#777777"
      />
    </svg>
  ),
  "mic-orange": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.668C11.3833 11.668 12.5 10.5513 12.5 9.16797V4.16797C12.5 2.78464 11.3833 1.66797 10 1.66797C8.61668 1.66797 7.50001 2.78464 7.50001 4.16797V9.16797C7.50001 10.5513 8.61668 11.668 10 11.668ZM14.925 9.16797C14.5167 9.16797 14.175 9.46797 14.1083 9.8763C13.7667 11.8346 12.0583 13.3346 10 13.3346C7.94168 13.3346 6.23334 11.8346 5.89168 9.8763C5.82501 9.46797 5.48334 9.16797 5.07501 9.16797C4.56668 9.16797 4.16668 9.61797 4.24168 10.118C4.65001 12.618 6.65001 14.5763 9.16668 14.9346V16.668C9.16668 17.1263 9.54168 17.5013 10 17.5013C10.4583 17.5013 10.8333 17.1263 10.8333 16.668V14.9346C13.35 14.5763 15.35 12.618 15.7583 10.118C15.8417 9.61797 15.4333 9.16797 14.925 9.16797Z"
        fill="#F88C00"
      />
    </svg>
  ),
  "more-horiz": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        fill="#777777"
      />
    </svg>
  ),
  liked: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3721 4.123C10.3721 2.45471 9.61744 1.5258 8.1081 1.33627C8.0779 1.33248 8.04743 1.33123 8.01701 1.33253C7.72768 1.34493 7.50356 1.58092 7.51641 1.85963L7.62859 4.28884C7.55125 5.18155 7.0342 6.07444 6.07743 6.96753L5.96555 7.07733C5.42556 7.63512 5.17665 8.32422 5.21881 9.14465L5.21914 12.7398C5.23164 13.6318 5.6183 14.6236 9.73289 14.6236C12.5258 14.6236 13.7924 14.0829 13.5327 13.0015C14.0674 12.809 14.368 12.5214 14.4343 12.1385C14.5007 11.7557 14.4017 11.4208 14.1376 11.1338C14.6868 10.804 14.9614 10.3796 14.9614 9.86078C14.9614 9.34193 14.7226 8.94207 14.2449 8.66123C14.5513 8.4384 14.6162 8.20523 14.6162 7.96172C14.6162 6.97356 13.1661 6.44857 10.0891 6.38675C10.2778 5.21477 10.3721 4.46019 10.3721 4.123ZM2.00004 7.9987C1.63185 7.9987 1.33337 8.29718 1.33337 8.66536V13.9987C1.33337 14.3669 1.63185 14.6654 2.00004 14.6654H4.00004C4.36823 14.6654 4.66671 14.3669 4.66671 13.9987V8.66536C4.66671 8.29717 4.36823 7.9987 4.00004 7.9987H2.00004Z"
        fill="#038CF5"
      />
    </svg>
  ),
  "arrow-bend-down": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 6.5L14 9.5L11 12.5"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3.5C2 5.0913 2.63214 6.61742 3.75736 7.74264C4.88258 8.86786 6.4087 9.5 8 9.5H14"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "react-like-fb": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81871 7.0625C1.58137 7.0625 1.33337 8.57249 1.33337 8.83183V12.3292C1.33337 12.5892 1.58071 14.0985 2.81871 14.0985H2.8927C3.21404 14.09 3.51936 13.9563 3.74353 13.7259C3.9677 13.4955 4.093 13.1866 4.09271 12.8652V8.29783C4.09317 7.97626 3.96794 7.66723 3.74375 7.43669C3.51957 7.20615 3.21416 7.07234 2.8927 7.06382L2.81871 7.0625Z"
        stroke="#777777"
        strokeWidth="1.5"
      />
      <path
        d="M11.5572 5.97116C11.1033 5.952 10.6485 5.97163 10.1979 6.02983C10.4674 5.61996 10.6229 5.14568 10.6483 4.65579C10.6737 4.1659 10.5682 3.67807 10.3426 3.2425C10.1589 2.74624 9.79555 2.33703 9.32455 2.09583C9.19372 2.02936 9.0484 1.99652 8.9017 2.00029C8.755 2.00407 8.61156 2.04433 8.48432 2.11744C8.35709 2.19055 8.25007 2.29421 8.17294 2.41905C8.09581 2.5439 8.051 2.68598 8.04255 2.83249C8.03485 3.18644 8.05537 3.54046 8.10389 3.89116C8.29589 4.83516 7.95787 5.21715 7.21654 5.83249C7.21654 5.83249 5.80587 7.0485 5.80587 8.03783C5.80587 8.6585 5.78055 9.20316 5.81855 11.5605C5.85655 13.9178 9.27855 13.5212 11.4132 13.4065C11.8875 13.4067 12.3537 13.284 12.7665 13.0505C14.4005 12.3425 14.5432 10.4718 14.5432 7.98983C14.5432 5.50783 11.5572 5.97116 11.5572 5.97116Z"
        stroke="#777777"
        strokeWidth="1.5"
      />
    </svg>
  ),
  "arrow-back-red": (
    <svg
      width="7"
      height="20"
      viewBox="0 0 7 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25833 13.2331L2.02499 9.99974L5.25833 6.76641C5.58333 6.44141 5.58333 5.91641 5.25833 5.59141C4.93333 5.26641 4.40833 5.26641 4.08333 5.59141L0.258325 9.41641C-0.0666752 9.74141 -0.0666752 10.2664 0.258325 10.5914L4.08333 14.4164C4.40833 14.7414 4.93333 14.7414 5.25833 14.4164C5.57499 14.0914 5.58333 13.5581 5.25833 13.2331Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "pen-red": (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37333 6.51333L9.98667 7.12667L3.94667 13.1667H3.33333V12.5533L9.37333 6.51333ZM11.7733 2.5C11.6067 2.5 11.4333 2.56667 11.3067 2.69333L10.0867 3.91333L12.5867 6.41333L13.8067 5.19333C14.0667 4.93333 14.0667 4.51333 13.8067 4.25333L12.2467 2.69333C12.1133 2.56 11.9467 2.5 11.7733 2.5ZM9.37333 4.62667L2 12V14.5H4.5L11.8733 7.12667L9.37333 4.62667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  fall: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
        fill="#ED1117"
        stroke="#ED1117"
        strokeWidth="0.00111607"
      />
      <path
        d="M14.4004 13.3008C14.4628 13.2383 14.5641 13.2383 14.6266 13.3008L15.2842 13.9584C15.3467 14.0209 15.3467 14.1222 15.2842 14.1847L12.6821 16.7868C12.6196 16.8493 12.5183 16.8493 12.4558 16.7868L11.7982 16.1292C11.7357 16.0667 11.7357 15.9654 11.7982 15.9029L14.4004 13.3008Z"
        fill="#ED1117"
      />
      <path
        d="M11.7982 14.1847C11.7357 14.1222 11.7357 14.0209 11.7982 13.9584L12.4558 13.3008C12.5183 13.2383 12.6196 13.2383 12.6821 13.3008L15.2842 15.9029C15.3467 15.9654 15.3467 16.0667 15.2842 16.1292L14.6266 16.7868C14.5641 16.8493 14.4628 16.8493 14.4004 16.7868L11.7982 14.1847Z"
        fill="#ED1117"
      />
    </svg>
  ),
  elect: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0076 15.2436L13.008 15.2433L13.009 15.2425L14.4254 13.2841L14.425 13.2838L14.4255 13.2841C14.4588 13.2374 14.5122 13.2107 14.5701 13.2107H15.5589C15.7036 13.2107 15.7881 13.3753 15.7013 13.4933L13.1522 17.02C13.081 17.1179 12.9364 17.1179 12.8652 17.02L11.2179 14.741C11.1333 14.6231 11.2179 14.4584 11.3625 14.4584H12.3469C12.3751 14.4582 12.403 14.4647 12.4281 14.4775C12.4533 14.4903 12.475 14.5089 12.4915 14.5319L13.0071 15.2439L13.0076 15.2436ZM13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
        fill="#0D99FF"
        stroke="#0D99FF"
        strokeWidth="0.00111607"
      />
    </svg>
  ),
  "shopping-bag": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3334 7.63987H14.3417L10.6917 2.42747C10.5334 2.20499 10.2667 2.09375 10 2.09375C9.73337 2.09375 9.46671 2.20499 9.30837 2.43542L5.65837 7.63987H1.66671C1.20837 7.63987 0.833374 7.99743 0.833374 8.43445C0.833374 8.50596 0.841707 8.57747 0.866707 8.64898L2.98337 16.0147C3.17504 16.6821 3.81671 17.1748 4.58337 17.1748H15.4167C16.1834 17.1748 16.825 16.6821 17.025 16.0147L19.1417 8.64898L19.1667 8.43445C19.1667 7.99743 18.7917 7.63987 18.3334 7.63987ZM10 4.30266L12.3334 7.63987H7.66671L10 4.30266ZM15.4167 15.5856L4.59171 15.5936L2.75837 9.22902H17.25L15.4167 15.5856ZM10 10.8182C9.08337 10.8182 8.33337 11.5333 8.33337 12.4073C8.33337 13.2813 9.08337 13.9965 10 13.9965C10.9167 13.9965 11.6667 13.2813 11.6667 12.4073C11.6667 11.5333 10.9167 10.8182 10 10.8182Z"
        fill="#212529"
      />
    </svg>
  ),
  "login-facebook": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_2296_73794)" />
      <path
        d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2296_73794"
          x1="16"
          y1="2"
          x2="16"
          y2="29.917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18ACFE" />
          <stop offset="1" stopColor="#0163E0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "login-google": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.0014 16.3114C30.0014 15.1603 29.9061 14.3203 29.6998 13.4492H16.2871V18.6447H24.1601C24.0014 19.9359 23.1442 21.8803 21.2394 23.1869L21.2127 23.3609L25.4536 26.5805L25.7474 26.6092C28.4458 24.167 30.0014 20.5736 30.0014 16.3114Z"
        fill="#4285F4"
      />
      <path
        d="M16.2863 30.0008C20.1434 30.0008 23.3814 28.7562 25.7466 26.6096L21.2386 23.1873C20.0323 24.0117 18.4132 24.5873 16.2863 24.5873C12.5086 24.5873 9.30225 22.1451 8.15929 18.7695L7.99176 18.7835L3.58208 22.128L3.52441 22.2851C5.87359 26.8584 10.699 30.0008 16.2863 30.0008Z"
        fill="#34A853"
      />
      <path
        d="M8.15964 18.7699C7.85806 17.8988 7.68352 16.9654 7.68352 16.001C7.68352 15.0365 7.85806 14.1032 8.14377 13.2321L8.13578 13.0466L3.67083 9.64844L3.52475 9.71653C2.55654 11.6143 2.00098 13.7455 2.00098 16.001C2.00098 18.2566 2.55654 20.3876 3.52475 22.2854L8.15964 18.7699Z"
        fill="#FBBC05"
      />
      <path
        d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
        fill="#EB4335"
      />
    </svg>
  ),
  info: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "dot-black": (
    <svg
      width="4"
      height="4"
      viewBox="0 0 4 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="2" fill="#212529" />
    </svg>
  ),
  "person-seminar": (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99992 5.50004C10.9166 5.50004 11.6666 6.25004 11.6666 7.16671C11.6666 8.08337 10.9166 8.83337 9.99992 8.83337C9.08325 8.83337 8.33325 8.08337 8.33325 7.16671C8.33325 6.25004 9.08325 5.50004 9.99992 5.50004ZM9.99992 13.8334C12.2499 13.8334 14.8333 14.9084 14.9999 15.5H4.99992C5.19159 14.9 7.75825 13.8334 9.99992 13.8334ZM9.99992 3.83337C8.15825 3.83337 6.66659 5.32504 6.66659 7.16671C6.66659 9.00837 8.15825 10.5 9.99992 10.5C11.8416 10.5 13.3333 9.00837 13.3333 7.16671C13.3333 5.32504 11.8416 3.83337 9.99992 3.83337ZM9.99992 12.1667C7.77492 12.1667 3.33325 13.2834 3.33325 15.5V17.1667H16.6666V15.5C16.6666 13.2834 12.2249 12.1667 9.99992 12.1667Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  "edit-seminar": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#00AEAC"
      />
    </svg>
  ),
  reply: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.83335 7.50152V6.17652C8.83335 5.43485 7.93335 5.05985 7.40835 5.58485L3.58335 9.40985C3.25835 9.73485 3.25835 10.2599 3.58335 10.5849L7.40835 14.4099C7.93335 14.9349 8.83335 14.5682 8.83335 13.8265V12.4182C13 12.4182 15.9167 13.7515 18 16.6682C17.1667 12.5015 14.6667 8.33485 8.83335 7.50152Z"
        fill="#F88C00"
      />
    </svg>
  ),
  "ellipe-blue": (
    <svg
      width="4"
      height="5"
      viewBox="0 0 4 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2.5" r="2" fill="#0D99FF" />
    </svg>
  ),
  ellipe: (
    <svg
      width="4"
      height="5"
      viewBox="0 0 4 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2.5" r="2" fill="#212529" />
    </svg>
  ),
  status_order_1: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12H26"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16L26 16"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20L26 20"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 31V5.875C4.5 5.57663 4.61853 5.29048 4.82951 5.07951C5.04048 4.86853 5.32663 4.75 5.625 4.75H30.375C30.6734 4.75 30.9595 4.86853 31.1705 5.07951C31.3815 5.29048 31.5 5.57663 31.5 5.875V31L26.5 27L22 31L17.5 27L13 31L8.5 27L4.5 31Z"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  status_order_2: (
    <svg
      width="31"
      height="34"
      viewBox="0 0 31 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.871 0C19.0599 0 19.2362 0.0541495 19.3851 0.147822C19.4462 0.186162 19.5032 0.231446 19.5551 0.283306L26.522 7.2502C26.7033 7.43149 26.8051 7.67734 26.8051 7.93368V14.9877C26.8051 15.5216 26.3723 15.9543 25.8384 15.9543C25.3045 15.9543 24.8718 15.5216 24.8718 14.9877V8.90018H18.871C18.3372 8.90018 17.9044 8.46742 17.9044 7.93354V1.9335H1.93328V31.9782H13.8554C14.3892 31.9782 14.8221 32.4109 14.8221 32.9448C14.8221 33.4787 14.3892 33.9114 13.8554 33.9114H0.966638C0.432752 33.9114 0 33.4787 0 32.9448V0.966861C0 0.432975 0.432752 0.000146539 0.966638 0.000146539H18.8528L18.871 0ZM19.8377 6.9669V3.30002L23.5045 6.9669H19.8377ZM7.79414 10.9378C7.26032 10.9378 6.8275 11.3706 6.8275 11.9045C6.8275 12.4384 7.26032 12.8711 7.79414 12.8711H18.3141C18.848 12.8711 19.2808 12.4384 19.2808 11.9045C19.2808 11.3706 18.848 10.9378 18.3141 10.9378H7.79414ZM3.71822 16.3633C3.71822 15.8294 4.15097 15.3966 4.68486 15.3966H14.8218C15.3557 15.3966 15.7885 15.8294 15.7885 16.3633C15.7885 16.8972 15.3557 17.3299 14.8218 17.3299H4.68486C4.15097 17.3299 3.71822 16.8972 3.71822 16.3633ZM5.00702 19.8555C4.47314 19.8555 4.04038 20.2882 4.04038 20.8221C4.04038 21.356 4.47314 21.7887 5.00702 21.7887H11.0857C11.6195 21.7887 12.0523 21.356 12.0523 20.8221C12.0523 20.2882 11.6195 19.8555 11.0857 19.8555H5.00702ZM4.04038 25.2809C4.04038 24.747 4.47314 24.3143 5.00702 24.3143H10.18C10.7138 24.3143 11.1466 24.747 11.1466 25.2809C11.1466 25.8148 10.7138 26.2475 10.18 26.2475H5.00702C4.47314 26.2475 4.04038 25.8148 4.04038 25.2809ZM14.2644 25.0023C14.2644 21.1113 17.4186 17.957 21.3097 17.957C25.2006 17.957 28.3549 21.1113 28.3549 25.0023C28.3549 28.8933 25.2006 32.0475 21.3097 32.0475C17.4186 32.0475 14.2644 28.8933 14.2644 25.0023ZM21.3097 16.0238C16.3509 16.0238 12.331 20.0435 12.331 25.0023C12.331 29.961 16.3509 33.9809 21.3097 33.9809C26.2684 33.9809 30.2882 29.961 30.2882 25.0023C30.2882 20.0435 26.2684 16.0238 21.3097 16.0238Z"
        fill="#154398"
      />
      <path
        d="M21.2652 24.4158C23.0414 24.4158 24.4874 25.7011 24.4874 27.28C24.4874 28.61 23.4562 29.7217 22.0707 30.0421V30.7707C22.0707 31.2156 21.7101 31.5762 21.2652 31.5762C20.8203 31.5762 20.4596 31.2156 20.4596 30.7707V30.0421C19.3607 29.7879 18.4847 29.036 18.1694 28.0722C18.031 27.6494 18.4036 27.28 18.8486 27.28C19.2934 27.28 19.6414 27.6706 19.8968 28.0349C20.1814 28.4411 20.6885 28.712 21.2652 28.712C22.1533 28.712 22.8762 28.0694 22.8762 27.28C22.8762 26.4905 22.1533 25.8479 21.2652 25.8479C19.489 25.8479 18.043 24.5626 18.043 22.9837C18.043 21.6537 19.0741 20.542 20.4596 20.2216V19.493C20.4596 19.0482 20.8203 18.6875 21.2652 18.6875C21.7101 18.6875 22.0707 19.0482 22.0707 19.493V20.2216C23.1697 20.4758 24.0456 21.2277 24.361 22.1915C24.4993 22.6143 24.1267 22.9837 23.6818 22.9837C23.2369 22.9837 22.8889 22.5931 22.6336 22.2288C22.3489 21.8226 21.8419 21.5517 21.2652 21.5517C20.377 21.5517 19.6541 22.1943 19.6541 22.9837C19.6541 23.7732 20.377 24.4158 21.2652 24.4158Z"
        fill="#154398"
      />
    </svg>
  ),
  status_order_3: (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1872_78335)">
        <path
          d="M28.7989 17.1729L14.5612 2.9352C14.7748 2.60565 14.7381 2.15405 14.4513 1.86111C14.1157 1.52546 13.5725 1.52546 13.2369 1.86111L3.47244 11.6255C3.13679 11.9612 3.13679 12.5043 3.47244 12.84C3.77148 13.139 4.16205 13.1878 4.54653 12.9498L18.7843 27.1876C20.9141 29.3174 25.1494 30.837 28.7989 27.1876C32.485 23.5015 30.8738 19.2479 28.7989 17.1729ZM5.77318 11.7476L13.365 4.16185L23.5017 14.2985H8.32413L5.77318 11.7476ZM27.5905 25.9731C24.9725 28.5912 21.4756 27.45 20.0048 25.9731L10.039 16.0134H25.2166L27.5905 18.3874C29.1223 19.9192 30.2452 23.3184 27.5905 25.9731Z"
          fill="#154398"
        />
        <path
          d="M4.74184 18.7475C4.57097 18.54 4.32075 18.418 4.05833 18.418C3.78981 18.418 3.5396 18.54 3.38093 18.7536C2.81337 19.486 0 23.2453 0 25.2042C0 27.4378 1.81862 29.2626 4.05833 29.2626C6.29194 29.2626 8.11667 27.4439 8.11667 25.2042C8.11667 23.2453 5.3033 19.486 4.74184 18.7475ZM4.05833 27.5477C2.77065 27.5477 1.72098 26.498 1.72098 25.2103C1.72098 24.3682 2.93543 22.3298 4.06444 20.7309C5.19345 22.3359 6.40179 24.3682 6.40179 25.2103C6.39569 26.498 5.34602 27.5477 4.05833 27.5477Z"
          fill="#154398"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_78335">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  status_order_4: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1872_78348)">
        <path
          d="M24.5508 4.79297C25.1836 5.42578 25.9746 5.0625 26.2441 4.79297C26.6602 4.37695 26.7539 3.60937 26.2441 3.09961L24.1641 1.01953C23.6953 0.550781 22.9395 0.550781 22.4707 1.01953C22.002 1.48828 22.002 2.24414 22.4707 2.71289L24.5508 4.79297Z"
          fill="#154398"
        />
        <path
          d="M28.1309 26.9902H19.4004C19.7227 26.7324 20.0273 26.457 20.3262 26.1641C24.4102 22.0801 24.6035 15.5527 20.9004 11.2344L24.1875 7.94727C24.6562 7.47852 24.6562 6.72266 24.1875 6.25391L21.0117 3.07812C20.543 2.60938 19.7871 2.60938 19.3184 3.07812L10.7812 11.6152C10.3125 12.084 10.3125 12.8398 10.7812 13.3086L11.5254 14.0527L10.5996 14.9785C10.1309 15.4473 10.1309 16.2031 10.5996 16.6719C11.0684 17.1406 11.8242 17.1406 12.293 16.6719L13.2188 15.7461L13.9629 16.4902C14.666 17.1465 15.4336 16.7363 15.6563 16.4902L19.207 12.9395C21.9785 16.3145 21.791 21.3242 18.6387 24.4766C16.9629 26.1523 14.7363 27.0371 12.3574 26.9961C12.3457 26.9961 12.3398 26.9961 12.3281 26.9961C12.3105 26.9961 12.2988 26.9961 12.2812 26.9961H8.90625V23.5391H10.6582C11.3203 23.5391 11.8535 23.0059 11.8535 22.3437C11.8535 21.6816 11.3203 21.1484 10.6582 21.1484H4.75195C4.08984 21.1484 3.55664 21.6816 3.55664 22.3437C3.55664 23.0059 4.08984 23.5391 4.75195 23.5391H6.50391V26.9961H1.81641C1.1543 26.9961 0.621094 27.5293 0.621094 28.1914C0.621094 28.8535 1.1543 29.3867 1.81641 29.3867H28.1367C28.7988 29.3867 29.332 28.8535 29.332 28.1914C29.332 27.5293 28.793 26.9902 28.1309 26.9902V26.9902ZM14.8008 13.9473L13.3184 12.4648L20.1621 5.61523L21.6445 7.09766L14.8008 13.9473V13.9473Z"
          fill="#154398"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_78348">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  status_order_5: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.23423 27.2986H14.1148C13.4494 26.7335 12.8844 26.0555 12.47 25.2771H7.34722C6.054 25.2771 5.36341 24.6116 5.36341 23.356V4.3591C5.36341 3.11608 6.04141 2.40042 7.34722 2.40042H20.468C21.7236 2.40042 22.4393 3.10355 22.4393 4.3591V15.3078C23.2178 15.7221 23.8958 16.2746 24.4608 16.94V4.32144C24.4608 1.69725 23.1676 0.378906 20.5685 0.378906H7.23423C4.64775 0.378906 3.34195 1.70983 3.34195 4.32144V23.3686C3.34195 25.9927 4.64775 27.2986 7.23423 27.2986ZM9.15525 7.52319H18.6726C19.112 7.52319 19.451 7.1716 19.451 6.73216C19.451 6.30525 19.112 5.97878 18.6726 5.97878H9.15525C8.69073 5.97878 8.36427 6.30525 8.36427 6.73216C8.36427 7.1716 8.69073 7.52319 9.15525 7.52319ZM9.15525 11.9051H18.6726C19.112 11.9051 19.451 11.5536 19.451 11.1141C19.451 10.6872 19.112 10.3608 18.6726 10.3608H9.15525C8.69073 10.3608 8.36427 10.6872 8.36427 11.1141C8.36427 11.5536 8.69073 11.9051 9.15525 11.9051ZM18.8232 27.2986C19.9533 27.2986 21.0205 26.9721 21.8994 26.382L24.7245 29.2196C25.0258 29.5084 25.3021 29.6214 25.6411 29.6214C26.2186 29.6214 26.6581 29.1694 26.6581 28.529C26.6581 28.2528 26.52 27.9766 26.3066 27.7631L23.4438 24.9004C24.0841 23.9838 24.4608 22.8664 24.4608 21.661C24.4608 18.5346 21.9371 16.0109 18.8232 16.0109C15.7094 16.0109 13.1606 18.5597 13.1606 21.661C13.1606 24.7749 15.7094 27.2986 18.8232 27.2986ZM18.8232 25.5031C16.6888 25.5031 14.9561 23.7829 14.9561 21.661C14.9561 19.5642 16.6888 17.8189 18.8232 17.8189C20.9201 17.8189 22.6527 19.5642 22.6527 21.661C22.6527 23.7829 20.9326 25.5031 18.8232 25.5031Z"
        fill="#154398"
      />
    </svg>
  ),
  status_order_6: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6203 26.8218L25.7128 31.3153C26.6194 31.8897 27.745 31.0354 27.476 29.9771L25.4268 21.9162C25.3691 21.6916 25.3759 21.4554 25.4465 21.2346C25.5171 21.0138 25.6486 20.8174 25.8258 20.668L32.1859 15.3744C33.0216 14.6788 32.5903 13.2919 31.5166 13.2222L23.2107 12.6832C22.987 12.6672 22.7724 12.588 22.592 12.4548C22.4115 12.3216 22.2727 12.1398 22.1915 11.9307L19.0938 4.12984C19.0096 3.90792 18.8598 3.71685 18.6645 3.58203C18.4691 3.44721 18.2374 3.375 18 3.375C17.7626 3.375 17.5309 3.44721 17.3355 3.58203C17.1402 3.71685 16.9904 3.90792 16.9062 4.12984L13.8085 11.9307C13.7273 12.1398 13.5885 12.3216 13.408 12.4548C13.2276 12.588 13.013 12.6672 12.7893 12.6832L4.48341 13.2222C3.40972 13.2919 2.97839 14.6788 3.81408 15.3744L10.1742 20.668C10.3514 20.8174 10.4829 21.0138 10.5535 21.2346C10.6241 21.4554 10.6309 21.6916 10.5732 21.9162L8.67282 29.3918C8.35 30.6617 9.70072 31.6869 10.7886 30.9976L17.3797 26.8218C17.5651 26.7038 17.7803 26.6411 18 26.6411C18.2197 26.6411 18.4349 26.7038 18.6203 26.8218V26.8218Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  status_order_7: (
    <svg
      width="55"
      height="54"
      viewBox="0 0 55 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 18V27"
        stroke="#ED1117"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 40V14.875C14 14.5766 14.1185 14.2905 14.3295 14.0795C14.5405 13.8685 14.8266 13.75 15.125 13.75H39.875C40.1734 13.75 40.4595 13.8685 40.6705 14.0795C40.8815 14.2905 41 14.5766 41 14.875V40L36 36L31.5 40L27 36L22.5 40L18 36L14 40Z"
        stroke="#ED1117"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="27.5" cy="30" r="1" fill="#ED1117" />
      <circle cx="27.5" cy="27" r="26" stroke="#ED1117" strokeWidth="2" />
    </svg>
  ),
  "date-range": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33464H15V2.5013C15 2.04297 14.625 1.66797 14.1667 1.66797C13.7083 1.66797 13.3333 2.04297 13.3333 2.5013V3.33464H6.66667V2.5013C6.66667 2.04297 6.29167 1.66797 5.83333 1.66797C5.375 1.66797 5 2.04297 5 2.5013V3.33464H4.16667C3.24167 3.33464 2.50833 4.08464 2.50833 5.0013L2.5 16.668C2.5 17.5846 3.24167 18.3346 4.16667 18.3346H15.8333C16.75 18.3346 17.5 17.5846 17.5 16.668V5.0013C17.5 4.08464 16.75 3.33464 15.8333 3.33464ZM15.8333 15.8346C15.8333 16.293 15.4583 16.668 15 16.668H5C4.54167 16.668 4.16667 16.293 4.16667 15.8346V7.5013H15.8333V15.8346ZM5.83333 9.16797H7.5V10.8346H5.83333V9.16797ZM9.16667 9.16797H10.8333V10.8346H9.16667V9.16797ZM12.5 9.16797H14.1667V10.8346H12.5V9.16797Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  person: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 5.4987C10.9166 5.4987 11.6666 6.2487 11.6666 7.16536C11.6666 8.08203 10.9166 8.83203 9.99998 8.83203C9.08331 8.83203 8.33331 8.08203 8.33331 7.16536C8.33331 6.2487 9.08331 5.4987 9.99998 5.4987ZM9.99998 13.832C12.25 13.832 14.8333 14.907 15 15.4987H4.99998C5.19165 14.8987 7.75831 13.832 9.99998 13.832ZM9.99998 3.83203C8.15831 3.83203 6.66665 5.3237 6.66665 7.16536C6.66665 9.00703 8.15831 10.4987 9.99998 10.4987C11.8416 10.4987 13.3333 9.00703 13.3333 7.16536C13.3333 5.3237 11.8416 3.83203 9.99998 3.83203ZM9.99998 12.1654C7.77498 12.1654 3.33331 13.282 3.33331 15.4987V17.1654H16.6666V15.4987C16.6666 13.282 12.225 12.1654 9.99998 12.1654Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  "delete-small": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="white" />
      <path
        d="M7.99992 1.33301C4.31325 1.33301 1.33325 4.31301 1.33325 7.99967C1.33325 11.6863 4.31325 14.6663 7.99992 14.6663C11.6866 14.6663 14.6666 11.6863 14.6666 7.99967C14.6666 4.31301 11.6866 1.33301 7.99992 1.33301ZM10.8666 10.8663C10.6066 11.1263 10.1866 11.1263 9.92659 10.8663L7.99992 8.93967L6.07325 10.8663C5.81325 11.1263 5.39325 11.1263 5.13325 10.8663C4.87325 10.6063 4.87325 10.1863 5.13325 9.92634L7.05992 7.99967L5.13325 6.07301C4.87325 5.81301 4.87325 5.39301 5.13325 5.13301C5.39325 4.87301 5.81325 4.87301 6.07325 5.13301L7.99992 7.05967L9.92659 5.13301C10.1866 4.87301 10.6066 4.87301 10.8666 5.13301C11.1266 5.39301 11.1266 5.81301 10.8666 6.07301L8.93992 7.99967L10.8666 9.92634C11.1199 10.1797 11.1199 10.6063 10.8666 10.8663Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "person-register": (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_17715)"
        stroke="url(#paint1_linear_1801_17715)"
        strokeWidth="2"
      />
      <path
        d="M39.9997 40.5007C44.0513 40.5007 47.333 37.219 47.333 33.1673C47.333 29.1157 44.0513 25.834 39.9997 25.834C35.948 25.834 32.6663 29.1157 32.6663 33.1673C32.6663 37.219 35.948 40.5007 39.9997 40.5007ZM39.9997 44.1673C35.1047 44.1673 25.333 46.624 25.333 51.5007V53.334C25.333 54.3423 26.158 55.1673 27.1663 55.1673H52.833C53.8413 55.1673 54.6663 54.3423 54.6663 53.334V51.5007C54.6663 46.624 44.8947 44.1673 39.9997 44.1673Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_17715"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D99F" />
          <stop offset="1" stopColor="#31966D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_17715"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#31966D" />
          <stop offset="1" stopColor="#82D99F" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "enterprise-register": (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_4689)"
        stroke="url(#paint1_linear_1801_4689)"
        strokeWidth="2"
      />
      <path
        d="M40.0003 22.166C29.8803 22.166 21.667 30.3793 21.667 40.4993C21.667 50.6193 29.8803 58.8327 40.0003 58.8327C50.1203 58.8327 58.3337 50.6193 58.3337 40.4993C58.3337 30.3793 50.1203 22.166 40.0003 22.166ZM46.6187 33.7893C48.5803 33.7893 50.157 35.366 50.157 37.3277C50.157 39.2893 48.5803 40.866 46.6187 40.866C44.657 40.866 43.0803 39.2893 43.0803 37.3277C43.062 35.366 44.657 33.7893 46.6187 33.7893ZM35.6187 30.8927C38.002 30.8927 39.9453 32.836 39.9453 35.2193C39.9453 37.6027 38.002 39.546 35.6187 39.546C33.2353 39.546 31.292 37.6027 31.292 35.2193C31.292 32.8177 33.217 30.8927 35.6187 30.8927ZM35.6187 47.631V54.506C31.2187 53.131 27.7353 49.7393 26.1953 45.4127C28.1203 43.3593 32.9237 42.3143 35.6187 42.3143C36.5903 42.3143 37.8187 42.461 39.102 42.7177C36.0953 44.3127 35.6187 46.421 35.6187 47.631ZM40.0003 55.166C39.5053 55.166 39.0287 55.1477 38.552 55.0927V47.631C38.552 45.0277 43.942 43.726 46.6187 43.726C48.5803 43.726 51.972 44.441 53.6587 45.8343C51.5137 51.2793 46.2153 55.166 40.0003 55.166Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_4689"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1BC9A" />
          <stop offset="1" stopColor="#BD9C6D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_4689"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BD9C6D" />
          <stop offset="1" stopColor="#D1BC9A" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "test-site-register": (
    <svg
      width="80"
      height="81"
      viewBox="0 0 80 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_17703)"
        stroke="url(#paint1_linear_1801_17703)"
        strokeWidth="2"
      />
      <path
        d="M39.9997 38.666C37.5613 38.666 32.6663 39.8944 32.6663 42.3327V42.626C34.4447 44.6793 37.0663 45.9993 39.9997 45.9993C42.933 45.9993 45.5547 44.6793 47.333 42.626V42.3327C47.333 39.8944 42.438 38.666 39.9997 38.666ZM39.9997 36.8327C42.0163 36.8327 43.6663 35.1827 43.6663 33.166C43.6663 31.1493 42.0163 29.4993 39.9997 29.4993C37.983 29.4993 36.333 31.1493 36.333 33.166C36.333 35.1827 37.983 36.8327 39.9997 36.8327ZM39.9997 22.166C47.6997 22.166 54.6663 28.0693 54.6663 37.1993C54.6663 43.0293 50.1747 49.886 41.2097 57.7877C40.513 58.3927 39.468 58.3927 38.7713 57.7877C29.8247 49.886 25.333 43.0293 25.333 37.1993C25.333 28.0693 32.2997 22.166 39.9997 22.166Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_17703"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5CD9E1" />
          <stop offset="1" stopColor="#01AFEF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_17703"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01AFEF" />
          <stop offset="1" stopColor="#5CD9E1" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "delete-outline": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99999 15.8333C4.99999 16.75 5.74999 17.5 6.66666 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V7.5C15 6.58333 14.25 5.83333 13.3333 5.83333H6.66666C5.74999 5.83333 4.99999 6.58333 4.99999 7.5V15.8333ZM7.49999 7.5H12.5C12.9583 7.5 13.3333 7.875 13.3333 8.33333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333H7.49999C7.04166 15.8333 6.66666 15.4583 6.66666 15V8.33333C6.66666 7.875 7.04166 7.5 7.49999 7.5ZM12.9167 3.33333L12.325 2.74167C12.175 2.59167 11.9583 2.5 11.7417 2.5H8.25832C8.04166 2.5 7.82499 2.59167 7.67499 2.74167L7.08332 3.33333H4.99999C4.54166 3.33333 4.16666 3.70833 4.16666 4.16667C4.16666 4.625 4.54166 5 4.99999 5H15C15.4583 5 15.8333 4.625 15.8333 4.16667C15.8333 3.70833 15.4583 3.33333 15 3.33333H12.9167Z"
        fill="#FF4648"
      />
    </svg>
  ),
  "face-book": (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_1615_165267)" />
      <path
        d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1615_165267"
          x1="16"
          y1="2"
          x2="16"
          y2="29.917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18ACFE" />
          <stop offset="1" stopColor="#0163E0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "reset-pass": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4555 14.1025L16.458 14.1037L16.5258 13.9967C16.5599 13.9444 16.5934 13.8917 16.6262 13.8385L16.6979 13.7253C16.7268 13.6798 16.7745 13.6444 16.8328 13.6301C16.8914 13.6158 16.953 13.6246 17.0039 13.6535C17.0544 13.6822 17.0889 13.7274 17.1032 13.7772C17.117 13.825 17.1122 13.8762 17.0889 13.9214C16.0338 15.7067 14.3005 17.014 12.2636 17.5555C10.2233 18.0978 8.0473 17.8266 6.21128 16.8022L6.19596 16.7936L6.18007 16.7862C6.16638 16.7797 6.15321 16.7724 6.14066 16.7643L6.12968 16.7572L6.11834 16.7507C4.30214 15.708 2.98108 14.0073 2.43795 12.0195C1.8949 10.0321 2.17232 7.91454 3.21137 6.1251L3.22063 6.10915L3.22869 6.09257C3.23419 6.08124 3.24077 6.07028 3.24838 6.05985L3.26155 6.0418L3.27306 6.02264C4.34172 4.24421 6.08568 2.94912 8.12733 2.42299C10.1692 1.89681 12.34 2.18332 14.1663 3.21888L14.1678 3.21975C15.3734 3.89773 16.375 4.87352 17.0735 6.04853L17.684 7.07548L17.987 5.91985L18.1294 5.37667L18.1314 5.36906L18.1331 5.36138C18.1405 5.32897 18.1546 5.29779 18.1751 5.2698C18.1955 5.24179 18.222 5.21744 18.2534 5.19866C18.2847 5.17987 18.3201 5.16717 18.3574 5.16172L18.2851 4.66697L18.3574 5.16172C18.3947 5.15626 18.4328 5.15824 18.4692 5.16745C18.5056 5.17667 18.5391 5.19282 18.568 5.21449L18.8682 4.81466L18.568 5.21449C18.5968 5.23615 18.6203 5.26277 18.6374 5.29238C18.6546 5.32197 18.6652 5.35414 18.6691 5.38699C18.673 5.41982 18.6701 5.45315 18.6606 5.48514L18.6582 5.49312L18.6561 5.50118L18.1306 7.50073C18.1252 7.52108 18.1174 7.5409 18.107 7.55977L18.0946 7.58257L18.0846 7.60653C18.0622 7.65997 18.0208 7.70647 17.9651 7.73633C17.9093 7.76625 17.8436 7.77687 17.7797 7.76545C17.7796 7.76544 17.7796 7.76543 17.7795 7.76542L15.7139 7.39161C15.7137 7.39157 15.7135 7.39154 15.7134 7.39151C15.6772 7.38479 15.6432 7.37127 15.6132 7.35209L15.3438 7.77327L15.6132 7.35209C15.5831 7.33284 15.5579 7.30839 15.5384 7.28054C15.519 7.25273 15.5058 7.22196 15.4989 7.19008L15.01 7.29492L15.4989 7.19007C15.4921 7.1582 15.4917 7.12542 15.4978 7.09345C15.504 7.06146 15.5165 7.03047 15.5353 7.00232C15.554 6.97414 15.5787 6.94921 15.6083 6.92936C15.6379 6.9095 15.6717 6.89523 15.7079 6.88778C15.744 6.88033 15.7814 6.87992 15.8178 6.88661L15.8192 6.88687L16.1511 6.94691L17.2461 7.14506L16.6671 6.19473C15.9925 5.08767 15.0361 4.17321 13.8931 3.54049C12.7501 2.9078 11.4595 2.57835 10.1482 2.58392C8.83691 2.5895 7.5492 2.92992 6.41184 3.57232C5.27442 4.21476 4.32615 5.13736 3.66138 6.25015L3.65673 6.25793L3.65236 6.26588L3.63603 6.29561C2.63557 7.99658 2.36267 10.0184 2.87862 11.9175C3.39518 13.8189 4.65921 15.4386 6.38966 16.4236L6.39083 16.4243C8.1251 17.4053 10.1845 17.6704 12.117 17.1624C13.8979 16.6943 15.4394 15.6041 16.4555 14.1025ZM10.9984 10.0601L11.9378 10.9943H11.9184L12.7925 11.8513L13.6114 12.6542L13.7501 12.7902L13.6494 12.8898L13.4997 12.743L13.1497 12.3998L12.7996 12.743L12.3564 13.1776L12.2517 13.0749L12.6808 12.6542L13.045 12.2972L12.6808 11.9401L12.2536 11.5212L11.9033 11.1778L11.5532 11.5215L10.9904 12.0742L10.8859 11.9718L11.4361 11.4324L11.8002 11.0754L11.4361 10.7184L11.1513 10.4391L10.8665 10.1598L10.5171 9.81734L10.1671 10.1591C9.80913 10.5086 9.32245 10.7065 8.81312 10.7065C8.3067 10.7065 7.82269 10.5108 7.46529 10.1651L7.4321 10.1302L7.43212 10.1302L7.42853 10.1265C7.08594 9.77396 6.89917 9.30612 6.905 8.82327C6.91084 8.34041 7.10889 7.8769 7.46005 7.53227L7.4608 7.53153L8.28356 6.72065C8.28361 6.7206 8.28367 6.72054 8.28373 6.72049C8.64128 6.36898 9.12865 6.16938 9.63916 6.16865C10.1498 6.16792 10.6378 6.36619 10.9964 6.71679C11.3547 7.06706 11.5546 7.54042 11.5553 8.03215C11.5561 8.52388 11.3576 8.99778 11.0004 9.34906L10.6399 9.70358L10.9984 10.0601ZM10.7512 6.93024L10.7513 6.9302L10.7457 6.92484C10.4471 6.63616 10.0466 6.47598 9.63129 6.47598C9.21599 6.47598 8.8155 6.63616 8.51687 6.92484L8.51557 6.9261L7.68814 7.73178L7.68812 7.73176L7.68425 7.73561C7.39639 8.02209 7.23004 8.40802 7.2226 8.81422C7.21516 9.22044 7.36729 9.61219 7.64468 9.90884L7.65647 9.92145L7.66911 9.93321L7.69474 9.95709C7.99313 10.2431 8.39189 10.4017 8.80528 10.4017C9.22026 10.4017 9.62049 10.2419 9.91924 9.9538L9.91925 9.95381L9.92131 9.9518L10.7473 9.14611L10.7473 9.14613L10.7512 9.14227C11.0454 8.84892 11.2121 8.4519 11.2121 8.03625C11.2121 7.62061 11.0454 7.22359 10.7512 6.93024Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  "cloud-upload": (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_631_26457)">
        <path
          d="M16.1344 8.46303L16.2085 8.8387L16.5905 8.86515C18.5001 8.99735 20 10.5675 20 12.4997C20 14.5235 18.3572 16.1663 16.3333 16.1663H5.5C3.01781 16.1663 1 14.1485 1 11.6663C1 9.34916 2.75498 7.43674 5.01119 7.19687L5.2779 7.16852L5.40179 6.93064C6.36089 5.08918 8.28562 3.83301 10.5 3.83301C13.2897 3.83301 15.613 5.81771 16.1344 8.46303ZM5.0822 7.86063L5.08188 7.86066C3.13251 8.06232 1.66667 9.70465 1.66667 11.6663C1.66667 13.7842 3.38219 15.4997 5.5 15.4997H16.3333C17.9845 15.4997 19.3333 14.1508 19.3333 12.4997C19.3333 10.9455 18.1134 9.63539 16.5506 9.53416C16.55 9.53412 16.5493 9.53407 16.5487 9.53403L15.6573 9.46993L15.4821 8.59402C15.4821 8.5938 15.482 8.59359 15.482 8.59338C15.0104 6.21857 12.9223 4.49967 10.5 4.49967C8.5954 4.49967 6.87563 5.55467 5.99857 7.243L5.70733 7.79636L5.0822 7.86063ZM9.79167 10.833V10.333H9.29167H8.37377L10.5 8.20678L12.6262 10.333H11.7083H11.2083V10.833V12.833H9.79167V10.833Z"
          fill="#0D99FF"
          stroke="#0D99FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_631_26457">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "green-accept": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM13.8253 6.31699L8.33366 11.8087L6.17533 9.65866L5.00033 10.8337L8.33366 14.167L15.0003 7.50033L13.8253 6.31699Z"
        fill="#00C590"
      />
    </svg>
  ),
  "cloud-icon": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6344 8.46303L15.7085 8.8387L16.0905 8.86515C18.0001 8.99735 19.5 10.5675 19.5 12.4997C19.5 14.5235 17.8572 16.1663 15.8333 16.1663H5C2.51781 16.1663 0.5 14.1485 0.5 11.6663C0.5 9.34916 2.25498 7.43674 4.51119 7.19687L4.7779 7.16852L4.90179 6.93064C5.86089 5.08918 7.78562 3.83301 10 3.83301C12.7897 3.83301 15.113 5.81771 15.6344 8.46303ZM4.5822 7.86063L4.58188 7.86066C2.63251 8.06232 1.16667 9.70465 1.16667 11.6663C1.16667 13.7842 2.88219 15.4997 5 15.4997H15.8333C17.4845 15.4997 18.8333 14.1508 18.8333 12.4997C18.8333 10.9455 17.6134 9.63539 16.0506 9.53416C16.05 9.53412 16.0493 9.53407 16.0487 9.53403L15.1573 9.46993L14.9821 8.59402C14.9821 8.5938 14.982 8.59359 14.982 8.59338C14.5104 6.21857 12.4223 4.49967 10 4.49967C8.0954 4.49967 6.37563 5.55467 5.49857 7.243L5.20733 7.79636L4.5822 7.86063ZM8.79167 11.333H9.29167V10.833V8.83301H10.7083V10.833V11.333H11.2083H12.1262L10 13.4592L7.87377 11.333H8.79167Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  "yellow-print": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8337 6.66667H15.0003V2.5H5.00033V6.66667H4.16699C2.78366 6.66667 1.66699 7.78333 1.66699 9.16667V14.1667H5.00033V17.5H15.0003V14.1667H18.3337V9.16667C18.3337 7.78333 17.217 6.66667 15.8337 6.66667ZM6.66699 4.16667H13.3337V6.66667H6.66699V4.16667ZM13.3337 14.1667V15.8333H6.66699V12.5H13.3337V14.1667ZM15.0003 12.5V10.8333H5.00033V12.5H3.33366V9.16667C3.33366 8.70833 3.70866 8.33333 4.16699 8.33333H15.8337C16.292 8.33333 16.667 8.70833 16.667 9.16667V12.5H15.0003Z"
        fill="#FEC328"
      />
      <path
        d="M15.3337 9.58333C15.3337 9.76743 15.1844 9.91667 15.0003 9.91667C14.8162 9.91667 14.667 9.76743 14.667 9.58333C14.667 9.39924 14.8162 9.25 15.0003 9.25C15.1844 9.25 15.3337 9.39924 15.3337 9.58333Z"
        fill="#FEC328"
        stroke="#FEC328"
      />
    </svg>
  ),
  "delete-box": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00002 15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333H5.00002V15.8333ZM6.66669 7.5H13.3334V15.8333H6.66669V7.5ZM12.9167 3.33333L12.0834 2.5H7.91669L7.08335 3.33333H4.16669V5H15.8334V3.33333H12.9167Z"
        fill="#666666"
      />
    </svg>
  ),
  "edit-box": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#666666"
      />
    </svg>
  ),
  "add-box": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM9.16667 14.1667H10.8333V10.8333H14.1667V9.16667H10.8333V5.83333H9.16667V9.16667H5.83333V10.8333H9.16667V14.1667Z"
        fill="#666666"
      />
    </svg>
  ),
  recallIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33335 7.49957V6.17457C8.33335 5.4329 7.43335 5.0579 6.90835 5.5829L3.08335 9.4079C2.75835 9.7329 2.75835 10.2579 3.08335 10.5829L6.90835 14.4079C7.43335 14.9329 8.33335 14.5662 8.33335 13.8246V12.4162C12.5 12.4162 15.4167 13.7496 17.5 16.6662C16.6667 12.4996 14.1667 8.3329 8.33335 7.49957Z"
        fill="#F88C00"
      />
    </svg>
  ),
  "code-request": (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2316_56202)">
        <path
          d="M2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V5H8C7.44688 5 7 4.55312 7 4V0H2ZM8 0V4H12L8 0ZM2.5 2H4.5C4.775 2 5 2.225 5 2.5C5 2.775 4.775 3 4.5 3H2.5C2.225 3 2 2.775 2 2.5C2 2.225 2.225 2 2.5 2ZM2.5 4H4.5C4.775 4 5 4.225 5 4.5C5 4.775 4.775 5 4.5 5H2.5C2.225 5 2 4.775 2 4.5C2 4.225 2.225 4 2.5 4ZM3 7H9C9.55313 7 10 7.44688 10 8V10C10 10.5531 9.55313 11 9 11H3C2.44688 11 2 10.5531 2 10V8C2 7.44688 2.44688 7 3 7ZM3 8V10H9V8H3ZM7.5 13H9.5C9.775 13 10 13.225 10 13.5C10 13.775 9.775 14 9.5 14H7.5C7.225 14 7 13.775 7 13.5C7 13.225 7.225 13 7.5 13Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_2316_56202">
          <rect width="12" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  location: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99992 10.0001C9.08325 10.0001 8.33325 9.25008 8.33325 8.33342C8.33325 7.41675 9.08325 6.66675 9.99992 6.66675C10.9166 6.66675 11.6666 7.41675 11.6666 8.33342C11.6666 9.25008 10.9166 10.0001 9.99992 10.0001ZM14.9999 8.50008C14.9999 5.47508 12.7916 3.33341 9.99992 3.33341C7.20825 3.33341 4.99992 5.47508 4.99992 8.50008C4.99992 10.4501 6.62492 13.0334 9.99992 16.1167C13.3749 13.0334 14.9999 10.4501 14.9999 8.50008ZM9.99992 1.66675C13.4999 1.66675 16.6666 4.35008 16.6666 8.50008C16.6666 11.2667 14.4416 14.5417 9.99992 18.3334C5.55825 14.5417 3.33325 11.2667 3.33325 8.50008C3.33325 4.35008 6.49992 1.66675 9.99992 1.66675Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  ship: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 6.65333L11.4734 6.65333L8.55342 2.28C8.42675 2.09333 8.21342 2 8.00008 2C7.78675 2 7.57342 2.09333 7.44675 2.28667L4.52675 6.65333H1.33341C0.966748 6.65333 0.666748 6.95333 0.666748 7.32C0.666748 7.38 0.673415 7.44 0.693415 7.5L2.38675 13.68C2.54008 14.24 3.05341 14.6533 3.66675 14.6533L12.3334 14.6533C12.9467 14.6533 13.4601 14.24 13.6201 13.68L15.3134 7.5L15.3334 7.32C15.3334 6.95333 15.0334 6.65333 14.6667 6.65333ZM8.00008 3.85333L9.86675 6.65333H6.13341L8.00008 3.85333ZM12.3334 13.32L3.67342 13.3267L2.20675 7.98667L13.8001 7.98667L12.3334 13.32ZM8.00008 9.32C7.26675 9.32 6.66675 9.92 6.66675 10.6533C6.66675 11.3867 7.26675 11.9867 8.00008 11.9867C8.73342 11.9867 9.33342 11.3867 9.33342 10.6533C9.33342 9.92 8.73342 9.32 8.00008 9.32Z"
        fill="black"
      />
    </svg>
  ),
  hiring: (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5164 3.97126V3.3284C11.5164 3.26948 11.4682 3.22126 11.4093 3.22126H6.26639C6.20746 3.22126 6.15925 3.26948 6.15925 3.3284V3.97126C6.15925 4.03019 6.20746 4.0784 6.26639 4.0784H11.4093C11.4682 4.0784 11.5164 4.03019 11.5164 3.97126ZM6.26639 5.14983C6.20746 5.14983 6.15925 5.19805 6.15925 5.25698V5.89983C6.15925 5.95876 6.20746 6.00698 6.26639 6.00698H8.73068C8.78961 6.00698 8.83782 5.95876 8.83782 5.89983V5.25698C8.83782 5.19805 8.78961 5.14983 8.73068 5.14983H6.26639ZM11.3021 6.7034C9.70434 6.7034 8.40925 7.99849 8.40925 9.59626C8.40925 11.194 9.70434 12.4891 11.3021 12.4891C12.8999 12.4891 14.195 11.194 14.195 9.59626C14.195 7.99849 12.8999 6.7034 11.3021 6.7034ZM12.7418 11.036C12.3575 11.4204 11.8459 11.632 11.3021 11.632C10.7584 11.632 10.2467 11.4204 9.86237 11.036C9.478 10.6516 9.26639 10.14 9.26639 9.59626C9.26639 9.05251 9.478 8.5409 9.86237 8.15653C10.2467 7.77215 10.7584 7.56055 11.3021 7.56055C11.8459 7.56055 12.3575 7.77215 12.7418 8.15653C13.1262 8.5409 13.3378 9.05251 13.3378 9.59626C13.3378 10.14 13.1262 10.6516 12.7418 11.036ZM12.4941 8.5784H11.9008C11.8659 8.5784 11.8338 8.59448 11.8137 8.6226L10.9633 9.79849L10.6539 9.37126C10.644 9.35746 10.6309 9.34624 10.6158 9.33855C10.6006 9.33086 10.5838 9.32692 10.5668 9.32707H9.97621C9.88916 9.32707 9.83827 9.42617 9.88916 9.49715L10.8776 10.8646C10.9204 10.9235 11.0075 10.9235 11.0503 10.8646L12.5798 8.74849C12.632 8.67751 12.5811 8.5784 12.4941 8.5784ZM8.19496 11.2034H5.08782V1.77483H12.5878V6.38198C12.5878 6.4409 12.636 6.48912 12.695 6.48912H13.445C13.5039 6.48912 13.5521 6.4409 13.5521 6.38198V1.23912C13.5521 1.00206 13.3606 0.810547 13.1235 0.810547H4.55211C4.31505 0.810547 4.12354 1.00206 4.12354 1.23912V11.7391C4.12354 11.9762 4.31505 12.1677 4.55211 12.1677H8.19496C8.25389 12.1677 8.30211 12.1195 8.30211 12.0605V11.3105C8.30211 11.2516 8.25389 11.2034 8.19496 11.2034Z"
        fill="#212529"
      />
    </svg>
  ),
  register: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.545 8.49935C12.0183 8.49935 13.2117 7.30602 13.2117 5.83268C13.2117 4.35935 12.0183 3.16602 10.545 3.16602C9.07167 3.16602 7.87834 4.35935 7.87834 5.83268C7.87834 7.30602 9.07167 8.49935 10.545 8.49935ZM10.545 4.49935C11.2783 4.49935 11.8783 5.09935 11.8783 5.83268C11.8783 6.56602 11.2783 7.16602 10.545 7.16602C9.81167 7.16602 9.21167 6.56602 9.21167 5.83268C9.21167 5.09935 9.81167 4.49935 10.545 4.49935ZM10.545 9.83268C8.765 9.83268 5.21167 10.726 5.21167 12.4993V13.8327H15.8783V12.4993C15.8783 10.726 12.325 9.83268 10.545 9.83268ZM6.545 12.4993C6.69167 12.0193 8.75167 11.166 10.545 11.166C12.345 11.166 14.4117 12.026 14.545 12.4993H6.545ZM4.545 10.4993V8.49935H6.545V7.16602H4.545V5.16602H3.21167V7.16602H1.21167V8.49935H3.21167V10.4993H4.545Z"
        fill="black"
      />
    </svg>
  ),
  "next-ios": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M17.22 6.97664C18.3633 5.83331 20.2067 5.83331 21.35 6.97664L40.74 26.3666C41.65 27.2766 41.65 28.7466 40.74 29.6566L21.35 49.0466C20.2067 50.19 18.3633 50.19 17.22 49.0466C16.0767 47.9033 16.0767 46.06 17.22 44.9166L34.1133 28L17.1967 11.0833C16.0767 9.96331 16.0767 8.09664 17.22 6.97664Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  "back-ios": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M38.78 6.97664C37.6367 5.83331 35.7933 5.83331 34.65 6.97664L15.26 26.3666C14.35 27.2766 14.35 28.7466 15.26 29.6566L34.65 49.0466C35.7933 50.19 37.6367 50.19 38.78 49.0466C39.9233 47.9033 39.9233 46.06 38.78 44.9166L21.8867 28L38.8033 11.0833C39.9233 9.96331 39.9233 8.09664 38.78 6.97664Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  "playlist-add-check": (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 7.5H2.25C1.8375 7.5 1.5 7.8375 1.5 8.25C1.5 8.6625 1.8375 9 2.25 9H9.75C10.1625 9 10.5 8.6625 10.5 8.25C10.5 7.8375 10.1625 7.5 9.75 7.5ZM9.75 4.5H2.25C1.8375 4.5 1.5 4.8375 1.5 5.25C1.5 5.6625 1.8375 6 2.25 6H9.75C10.1625 6 10.5 5.6625 10.5 5.25C10.5 4.8375 10.1625 4.5 9.75 4.5ZM2.25 12H6.75C7.1625 12 7.5 11.6625 7.5 11.25C7.5 10.8375 7.1625 10.5 6.75 10.5H2.25C1.8375 10.5 1.5 10.8375 1.5 11.25C1.5 11.6625 1.8375 12 2.25 12ZM16.6575 9.1575L16.725 9.225C17.0175 9.5175 17.0175 9.99 16.725 10.2825L12.54 14.475C12.2475 14.7675 11.775 14.7675 11.4825 14.475L9.165 12.1575C8.8725 11.865 8.8725 11.3925 9.165 11.1L9.2325 11.0325C9.525 10.74 9.9975 10.74 10.29 11.0325L12.015 12.7575L15.6 9.165C15.885 8.865 16.365 8.865 16.6575 9.1575Z"
        fill="#666666"
      />
    </svg>
  ),

  "search-blue": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5006 14.0006H14.7106L14.4306 13.7306C15.6306 12.3306 16.2506 10.4206 15.9106 8.39063C15.4406 5.61063 13.1206 3.39063 10.3206 3.05063C6.09063 2.53063 2.53063 6.09063 3.05063 10.3206C3.39063 13.1206 5.61063 15.4406 8.39063 15.9106C10.4206 16.2506 12.3306 15.6306 13.7306 14.4306L14.0006 14.7106V15.5006L18.2506 19.7506C18.6606 20.1606 19.3306 20.1606 19.7406 19.7506C20.1506 19.3406 20.1506 18.6706 19.7406 18.2606L15.5006 14.0006ZM9.50063 14.0006C7.01063 14.0006 5.00063 11.9906 5.00063 9.50063C5.00063 7.01063 7.01063 5.00063 9.50063 5.00063C11.9906 5.00063 14.0006 7.01063 14.0006 9.50063C14.0006 11.9906 11.9906 14.0006 9.50063 14.0006Z"
        fill="#154398"
      />
    </svg>
  ),

  "star-green": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0003 17.5198L16.1503 20.0298C16.9103 20.4898 17.8403 19.8098 17.6403 18.9498L16.5403 14.2298L20.2103 11.0498C20.8803 10.4698 20.5203 9.36977 19.6403 9.29977L14.8103 8.88977L12.9203 4.42977C12.5803 3.61977 11.4203 3.61977 11.0803 4.42977L9.19032 8.87977L4.36032 9.28977C3.48032 9.35977 3.12032 10.4598 3.79032 11.0398L7.46032 14.2198L6.36032 18.9398C6.16032 19.7998 7.09032 20.4798 7.85032 20.0198L12.0003 17.5198Z"
        fill="#00C590"
      />
    </svg>
  ),

  "user-green": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
        fill="#00C590"
      />
    </svg>
  ),

  "library-books": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 11H10C9.45 11 9 10.55 9 10C9 9.45 9.45 9 10 9H18C18.55 9 19 9.45 19 10C19 10.55 18.55 11 18 11ZM14 15H10C9.45 15 9 14.55 9 14C9 13.45 9.45 13 10 13H14C14.55 13 15 13.45 15 14C15 14.55 14.55 15 14 15ZM18 7H10C9.45 7 9 6.55 9 6C9 5.45 9.45 5 10 5H18C18.55 5 19 5.45 19 6C19 6.55 18.55 7 18 7Z"
        fill="#00C590"
      />
    </svg>
  ),

  "video-youtube": (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="20" height="14" rx="3" fill="#777777" />
      <path
        d="M7.66797 4.03075V9.96617C7.66797 10.4188 8.17547 10.6938 8.5663 10.4474L13.3146 7.47971C13.6763 7.25627 13.6763 6.74065 13.3146 6.51148L8.5663 3.5495C8.17547 3.30315 7.66797 3.57815 7.66797 4.03075Z"
        fill="white"
      />
    </svg>
  ),

  up: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.11973 14.7105L11.9997 10.8305L15.8797 14.7105C16.2697 15.1005 16.8997 15.1005 17.2897 14.7105C17.6797 14.3205 17.6797 13.6905 17.2897 13.3005L12.6997 8.71047C12.3097 8.32047 11.6797 8.32047 11.2897 8.71047L6.69973 13.3005C6.30973 13.6905 6.30973 14.3205 6.69973 14.7105C7.08973 15.0905 7.72973 15.1005 8.11973 14.7105Z"
        fill="#ED1117"
      />
    </svg>
  ),

  infor: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
        fill="#00C590"
      />
    </svg>
  ),

  "shopping-cart-white": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill="white"
      />
    </svg>
  ),

  "check-green": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00009 10.7809L3.68676 8.46753C3.42676 8.20753 3.00676 8.20753 2.74676 8.46753C2.48676 8.72753 2.48676 9.14753 2.74676 9.40753L5.53342 12.1942C5.79342 12.4542 6.21342 12.4542 6.47342 12.1942L13.5268 5.14086C13.7868 4.88086 13.7868 4.46086 13.5268 4.20086C13.2668 3.94086 12.8468 3.94086 12.5868 4.20086L6.00009 10.7809Z"
        fill="#00C590"
      />
    </svg>
  ),

  "sms-message": (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 3.32031L2.66659 3.32031C1.93325 3.32031 1.33992 3.92031 1.33992 4.65365L1.33325 12.6536C1.33325 13.387 1.93325 13.987 2.66659 13.987L13.3333 13.987C14.0666 13.987 14.6666 13.387 14.6666 12.6536L14.6666 4.65365C14.6666 3.92031 14.0666 3.32031 13.3333 3.32031ZM12.6666 12.6536L3.33325 12.6536C2.96659 12.6536 2.66659 12.3536 2.66659 11.987L2.66659 5.98698L7.29325 8.88031C7.72659 9.15365 8.27325 9.15365 8.70659 8.88031L13.3333 5.98698L13.3333 11.987C13.3333 12.3536 13.0333 12.6536 12.6666 12.6536ZM7.99992 7.98698L2.66659 4.65365L13.3333 4.65365L7.99992 7.98698Z"
        fill="black"
      />
    </svg>
  ),

  "menu-book": (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 3.49609C11.6625 3.49609 10.0875 3.79609 9 4.62109C7.9125 3.79609 6.3375 3.49609 4.875 3.49609C3.7875 3.49609 2.6325 3.66109 1.665 4.08859C1.1175 4.33609 0.75 4.86859 0.75 5.47609V13.9361C0.75 14.9111 1.665 15.6311 2.61 15.3911C3.345 15.2036 4.125 15.1211 4.875 15.1211C6.045 15.1211 7.29 15.3161 8.295 15.8111C8.745 16.0361 9.255 16.0361 9.6975 15.8111C10.7025 15.3086 11.9475 15.1211 13.1175 15.1211C13.8675 15.1211 14.6475 15.2036 15.3825 15.3911C16.3275 15.6386 17.2425 14.9186 17.2425 13.9361V5.47609C17.2425 4.86859 16.875 4.33609 16.3275 4.08859C15.3675 3.66109 14.2125 3.49609 13.125 3.49609ZM15.75 13.0436C15.75 13.5161 15.315 13.8611 14.85 13.7786C14.2875 13.6736 13.7025 13.6286 13.125 13.6286C11.85 13.6286 10.0125 14.1161 9 14.7536V6.12109C10.0125 5.48359 11.85 4.99609 13.125 4.99609C13.815 4.99609 14.4975 5.06359 15.15 5.20609C15.495 5.28109 15.75 5.58859 15.75 5.94109V13.0436Z"
        fill="#666666"
      />
      <path
        d="M10.4854 8.37897C10.2454 8.37897 10.0279 8.22897 9.9529 7.98897C9.8554 7.69647 10.0204 7.37397 10.3129 7.28397C11.4679 6.90897 12.9604 6.78897 14.3329 6.94647C14.6404 6.98397 14.8654 7.26147 14.8279 7.56897C14.7904 7.87647 14.5129 8.10147 14.2054 8.06397C12.9904 7.92147 11.6629 8.03397 10.6579 8.35647C10.5979 8.36397 10.5379 8.37897 10.4854 8.37897Z"
        fill="#666666"
      />
      <path
        d="M10.4854 10.3751C10.2454 10.3751 10.0279 10.2251 9.9529 9.98507C9.8554 9.69257 10.0204 9.37007 10.3129 9.28007C11.4604 8.90507 12.9604 8.78507 14.3329 8.94257C14.6404 8.98007 14.8654 9.25757 14.8279 9.56507C14.7904 9.87257 14.5129 10.0976 14.2054 10.0601C12.9904 9.91757 11.6629 10.0301 10.6579 10.3526C10.5979 10.3676 10.5379 10.3751 10.4854 10.3751Z"
        fill="#666666"
      />
      <path
        d="M10.4854 12.3673C10.2454 12.3673 10.0279 12.2173 9.9529 11.9773C9.8554 11.6848 10.0204 11.3623 10.3129 11.2723C11.4604 10.8973 12.9604 10.7773 14.3329 10.9348C14.6404 10.9723 14.8654 11.2498 14.8279 11.5573C14.7904 11.8648 14.5129 12.0823 14.2054 12.0523C12.9904 11.9098 11.6629 12.0223 10.6579 12.3448C10.5979 12.3598 10.5379 12.3673 10.4854 12.3673Z"
        fill="#666666"
      />
    </svg>
  ),
  "supervisor-account": (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.375 9.12109C13.41 9.12109 14.2425 8.28109 14.2425 7.24609C14.2425 6.21109 13.41 5.37109 12.375 5.37109C11.34 5.37109 10.5 6.21109 10.5 7.24609C10.5 8.28109 11.34 9.12109 12.375 9.12109ZM6.75 8.37109C7.995 8.37109 8.9925 7.36609 8.9925 6.12109C8.9925 4.87609 7.995 3.87109 6.75 3.87109C5.505 3.87109 4.5 4.87609 4.5 6.12109C4.5 7.36609 5.505 8.37109 6.75 8.37109ZM12.375 10.6211C11.0025 10.6211 8.25 11.3111 8.25 12.6836V13.6211C8.25 14.0336 8.5875 14.3711 9 14.3711H15.75C16.1625 14.3711 16.5 14.0336 16.5 13.6211V12.6836C16.5 11.3111 13.7475 10.6211 12.375 10.6211ZM6.75 9.87109C5.0025 9.87109 1.5 10.7486 1.5 12.4961V13.6211C1.5 14.0336 1.8375 14.3711 2.25 14.3711H6.75V12.6836C6.75 12.0461 6.9975 10.9286 8.5275 10.0811C7.875 9.94609 7.245 9.87109 6.75 9.87109Z"
        fill="#666666"
      />
    </svg>
  ),
  "next-arrow-slide": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
      <path
        d="M14.1501 25.507C14.5584 25.9154 15.2167 25.9154 15.6251 25.507L22.5501 18.582C22.8751 18.257 22.8751 17.732 22.5501 17.407L15.6251 10.482C15.2167 10.0737 14.5584 10.0737 14.1501 10.482C13.7417 10.8904 13.7417 11.5487 14.1501 11.957L20.1834 17.9987L14.1417 24.0404C13.7417 24.4404 13.7417 25.107 14.1501 25.507Z"
        fill="#666666"
      />
    </svg>
  ),
  "prev-arrow-slide": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
      <path
        d="M21.8498 10.4898C21.4415 10.0815 20.7831 10.0815 20.3748 10.4898L13.4498 17.4148C13.1248 17.7398 13.1248 18.2648 13.4498 18.5898L20.3748 25.5148C20.7831 25.9232 21.4415 25.9232 21.8498 25.5148C22.2581 25.1065 22.2581 24.4482 21.8498 24.0398L15.8165 17.9982L21.8581 11.9565C22.2581 11.5565 22.2581 10.8898 21.8498 10.4898Z"
        fill="#666666"
      />
    </svg>
  ),
  "manual-step1": (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12425)" />
      <path
        d="M25 34.3346L23.9967 33.3313C22.62 31.9546 22.6317 29.7146 24.02 28.3613L25 27.4046C24.545 27.358 24.2067 27.3346 23.8333 27.3346C20.7183 27.3346 14.5 28.898 14.5 32.0013V34.3346H25ZM23.8333 25.0013C26.4117 25.0013 28.5 22.913 28.5 20.3346C28.5 17.7563 26.4117 15.668 23.8333 15.668C21.255 15.668 19.1667 17.7563 19.1667 20.3346C19.1667 22.913 21.255 25.0013 23.8333 25.0013Z"
        fill="white"
      />
      <path
        d="M29.8768 34.0765C29.4218 34.5315 28.6752 34.5315 28.2202 34.0765L25.8052 31.6382C25.3618 31.1832 25.3618 30.4598 25.8052 30.0165L25.8168 30.0048C26.2718 29.5498 27.0068 29.5498 27.4502 30.0048L29.0485 31.6032L34.2168 26.3998C34.6718 25.9448 35.4068 25.9448 35.8618 26.3998L35.8735 26.4115C36.3168 26.8665 36.3168 27.5898 35.8735 28.0332L29.8768 34.0765Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12425"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "manual-step2": (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12431)" />
      <path
        d="M22.6667 22.69H28.5V35.5H22.6667V22.69ZM30.8333 35.5H34.3333C35.6167 35.5 36.6667 34.45 36.6667 33.1667V22.6667H30.8333V35.5ZM34.3333 14.5H16.8333C15.55 14.5 14.5 15.55 14.5 16.8333V20.3333H36.6667V16.8333C36.6667 15.55 35.6167 14.5 34.3333 14.5ZM14.5 33.1667C14.5 34.45 15.55 35.5 16.8333 35.5H20.3333V22.6667H14.5V33.1667Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12431"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "manual-step3": (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12437)" />
      <path
        d="M33.1667 14.5013H28.29C27.8 13.148 26.5167 12.168 25 12.168C23.4833 12.168 22.2 13.148 21.71 14.5013H16.8333C15.55 14.5013 14.5 15.5513 14.5 16.8346V33.168C14.5 34.4513 15.55 35.5013 16.8333 35.5013H33.1667C34.45 35.5013 35.5 34.4513 35.5 33.168V16.8346C35.5 15.5513 34.45 14.5013 33.1667 14.5013ZM25 14.5013C25.6417 14.5013 26.1667 15.0263 26.1667 15.668C26.1667 16.3096 25.6417 16.8346 25 16.8346C24.3583 16.8346 23.8333 16.3096 23.8333 15.668C23.8333 15.0263 24.3583 14.5013 25 14.5013ZM25 19.168C26.9367 19.168 28.5 20.7313 28.5 22.668C28.5 24.6046 26.9367 26.168 25 26.168C23.0633 26.168 21.5 24.6046 21.5 22.668C21.5 20.7313 23.0633 19.168 25 19.168ZM32 33.168H18V31.5346C18 29.2013 22.6667 27.918 25 27.918C27.3333 27.918 32 29.2013 32 31.5346V33.168Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12437"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "manual-step4": (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12443)" />
      <path
        d="M24.9997 13.332C18.5597 13.332 13.333 18.5587 13.333 24.9987C13.333 31.4387 18.5597 36.6654 24.9997 36.6654C31.4397 36.6654 36.6663 31.4387 36.6663 24.9987C36.6663 18.5587 31.4397 13.332 24.9997 13.332ZM29.2113 20.7287C30.4597 20.7287 31.463 21.732 31.463 22.9804C31.463 24.2287 30.4597 25.232 29.2113 25.232C27.963 25.232 26.9597 24.2287 26.9597 22.9804C26.948 21.732 27.963 20.7287 29.2113 20.7287ZM22.2113 18.8854C23.728 18.8854 24.9647 20.122 24.9647 21.6387C24.9647 23.1554 23.728 24.392 22.2113 24.392C20.6947 24.392 19.458 23.1554 19.458 21.6387C19.458 20.1104 20.683 18.8854 22.2113 18.8854ZM22.2113 29.537V33.912C19.4113 33.037 17.1947 30.8787 16.2147 28.1254C17.4397 26.8187 20.4963 26.1537 22.2113 26.1537C22.8297 26.1537 23.6113 26.247 24.428 26.4104C22.5147 27.4254 22.2113 28.767 22.2113 29.537ZM24.9997 34.332C24.6847 34.332 24.3813 34.3204 24.078 34.2854V29.537C24.078 27.8804 27.508 27.052 29.2113 27.052C30.4597 27.052 32.618 27.507 33.6913 28.3937C32.3263 31.8587 28.9547 34.332 24.9997 34.332Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12443"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "file-excel-icon": (
    <svg
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_363_14496)">
        <path
          d="M4.25 0C1.90586 0 0 1.90586 0 4.25V29.75C0 32.0941 1.90586 34 4.25 34H21.25C23.5941 34 25.5 32.0941 25.5 29.75V10.625H17C15.8246 10.625 14.875 9.67539 14.875 8.5V0H4.25ZM17 0V8.5H25.5L17 0ZM10.3395 16.6148L12.75 20.0613L15.1605 16.6148C15.6652 15.891 16.6613 15.7184 17.3785 16.223C18.0957 16.7277 18.275 17.7238 17.7703 18.441L14.6957 22.8438L17.777 27.2398C18.2816 27.9637 18.109 28.9531 17.3852 29.4578C16.6613 29.9625 15.6719 29.7898 15.1672 29.066L12.75 25.6195L10.3395 29.066C9.83477 29.7898 8.83867 29.9625 8.12148 29.4578C7.4043 28.9531 7.225 27.957 7.72969 27.2398L10.8043 22.8438L7.72305 18.4477C7.21836 17.7238 7.39102 16.7344 8.11484 16.2297C8.83867 15.725 9.82812 15.8977 10.3328 16.6215L10.3395 16.6148Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_14496">
          <rect width="25.5" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "seminar-time": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M14.9917 6.66675C10.3917 6.66675 6.66675 10.4001 6.66675 15.0001C6.66675 19.6001 10.3917 23.3334 14.9917 23.3334C19.6001 23.3334 23.3334 19.6001 23.3334 15.0001C23.3334 10.4001 19.6001 6.66675 14.9917 6.66675ZM15.0001 21.6667C11.3167 21.6667 8.33341 18.6834 8.33341 15.0001C8.33341 11.3167 11.3167 8.33341 15.0001 8.33341C18.6834 8.33341 21.6667 11.3167 21.6667 15.0001C21.6667 18.6834 18.6834 21.6667 15.0001 21.6667ZM14.8167 10.8334H14.7667C14.4334 10.8334 14.1667 11.1001 14.1667 11.4334V15.3667C14.1667 15.6584 14.3167 15.9334 14.5751 16.0834L18.0334 18.1584C18.3167 18.3251 18.6834 18.2417 18.8501 17.9584C19.0251 17.6751 18.9334 17.3001 18.6417 17.1334L15.4167 15.2167V11.4334C15.4167 11.1001 15.1501 10.8334 14.8167 10.8334Z"
        fill="white"
      />
    </svg>
  ),
  "send-mess-primary": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7792 20.8284L21.8291 3.2002C22.1543 2.37995 21.3482 1.57385 20.528 1.89912L2.89982 8.94898C2.22807 9.21061 2.05837 10.0733 2.56041 10.5753L5.8131 13.8422C6.16666 14.1957 6.73234 14.2381 7.12832 13.927L18.4562 5.27202L9.79411 16.5928C9.49006 16.9959 9.53248 17.5615 9.88604 17.9151L13.1529 21.1678C13.6549 21.6698 14.5176 21.5001 14.7792 20.8284Z"
        fill="#154398"
      />
    </svg>
  ),
  "refresh-icon": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.709 5.29182C13.3507 3.93349 11.4257 3.15016 9.30904 3.36682C6.25071 3.67516 3.73404 6.15849 3.39238 9.21682C2.93404 13.2585 6.05904 16.6668 10.0007 16.6668C12.659 16.6668 14.9424 15.1085 16.009 12.8668C16.2757 12.3085 15.8757 11.6668 15.259 11.6668C14.9507 11.6668 14.659 11.8335 14.5257 12.1085C13.584 14.1335 11.3257 15.4168 8.85904 14.8668C7.00904 14.4585 5.51738 12.9502 5.12571 11.1002C4.42571 7.86682 6.88404 5.00016 10.0007 5.00016C11.384 5.00016 12.6174 5.57516 13.5174 6.48349L12.259 7.74182C11.734 8.26682 12.1007 9.16682 12.8424 9.16682H15.834C16.2924 9.16682 16.6674 8.79182 16.6674 8.33349V5.34182C16.6674 4.60016 15.7674 4.22516 15.2424 4.75016L14.709 5.29182Z"
        fill="#212529"
      />
    </svg>
  ),
  "face-sad": (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2563 61.051C28.4875 60.733 28.95 60.733 29.1812 61.051C30.1352 62.3012 32.1225 65.2207 32.1225 66.666C32.1225 68.5449 30.6338 70.0625 28.6537 70.0625C26.8037 70.0625 25.185 68.5449 25.185 66.666C25.185 65.2207 27.3168 62.3012 28.2563 61.051ZM42.5938 65.0617C43.3092 65.6977 43.367 66.7961 42.7311 67.5115C42.0879 68.227 40.9967 68.2848 40.2162 67.6488C38.742 66.2686 36.7186 65.4375 34.5 65.4375C33.5389 65.4375 32.7656 64.6643 32.7656 63.7031C32.7656 62.742 33.5389 61.9688 34.5 61.9688C37.6074 61.9688 40.4475 63.1395 42.5938 65.0617ZM40.2523 52.7188C41.5314 52.7188 42.5648 53.7521 42.5648 55.0312C42.5648 56.3104 41.5314 57.3438 40.2523 57.3438C38.9154 57.3438 37.9398 56.3104 37.9398 55.0312C37.9398 53.7521 38.9154 52.7188 40.2523 52.7188ZM28.6898 57.3438C27.3529 57.3438 26.3773 56.3104 26.3773 55.0312C26.3773 53.7521 27.3529 52.7188 28.6898 52.7188C29.9689 52.7188 31.0023 53.7521 31.0023 55.0312C31.0023 56.3104 29.9689 57.3438 28.6898 57.3438ZM34.5 40C44.7184 40 53 48.2816 53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40ZM28.7115 72.375C30.4893 73.1193 32.4477 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 62.3084 20.8844 65.7844 23.2179 68.4293C23.9781 70.7418 26.1822 72.3678 28.7115 72.375Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  "face-frown": (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.399 68.8051C25.4957 68.4799 25.026 67.4826 25.3512 66.5865C26.6158 63.0816 30.3736 60.8125 34.5 60.8125C38.6264 60.8125 42.3842 63.0816 43.6488 66.5865C43.974 67.4826 43.5043 68.4799 42.601 68.8051C41.7049 69.1303 40.7076 68.6605 40.3824 67.7572C39.7176 65.9072 37.4773 64.2812 34.5 64.2812C31.5227 64.2812 29.2824 65.9072 28.6176 67.7572C28.2924 68.6605 27.2951 69.1303 26.399 68.8051ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  "face-meh": (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312ZM42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312ZM39.7031 63.7031C40.6643 63.7031 41.4375 64.4764 41.4375 65.4375C41.4375 66.3986 40.6643 67.1719 39.7031 67.1719H29.2969C28.3357 67.1719 27.5625 66.3986 27.5625 65.4375C27.5625 64.4764 28.3357 63.7031 29.2969 63.7031H39.7031ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  "face-smile": (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5 65.4375C37.1883 65.4375 39.0672 64.1729 40.1656 62.9877C40.8088 62.2867 41.9072 62.2361 42.6154 62.8865C43.3164 63.5369 43.3598 64.6354 42.7094 65.3363C41.1268 67.0635 38.3807 68.9062 34.5 68.9062C30.6193 68.9062 27.8732 67.0635 26.2906 65.3363C25.6402 64.6354 25.6186 63.5369 26.3846 62.8865C27.0928 62.2361 28.1912 62.2867 28.8344 62.9877C29.9328 64.1729 31.8117 65.4375 34.5 65.4375ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  "face-grin-hearts": (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.2568 62.2867C42.6082 61.9037 43.8512 63.1539 43.0346 64.3174C41.3219 67.0707 38.135 68.8412 34.4928 68.8412C30.8578 68.8412 27.6709 67.0707 25.8932 64.3174C25.1416 63.1539 26.3846 61.9037 27.7287 62.2867C29.8244 62.7709 32.1008 63.0383 34.4928 63.0383C36.8848 63.0383 39.1684 62.7709 41.2568 62.2867ZM33.2643 52.7982L31.9996 57.5605C31.8334 58.182 31.2047 58.5434 30.5832 58.3771L25.8787 57.1197C24.5924 56.7729 23.8336 55.4504 24.1732 54.1713C24.5201 52.885 25.8426 52.1189 27.0639 52.4658L28.2924 52.7766L28.6031 51.6131C28.95 50.3268 30.2725 49.568 31.5588 49.9076C32.8451 50.2545 33.6039 51.577 33.2643 52.7982ZM40.7076 52.7766L41.8711 52.4658C43.1574 52.1189 44.4799 52.885 44.8268 54.1713C45.1664 55.4504 44.4076 56.7729 43.1213 57.1197L38.4168 58.3771C37.7953 58.5434 37.1666 58.182 37.0004 57.5605L35.7357 52.7982C35.3961 51.577 36.1549 50.2545 37.4412 49.9076C38.7275 49.568 40.05 50.3268 40.3969 51.6131L40.7076 52.7766ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  "order-step1": (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 21H35"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 25L35 25"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 29L35 29"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 40V14.875C13.5 14.5766 13.6185 14.2905 13.8295 14.0795C14.0405 13.8685 14.3266 13.75 14.625 13.75H39.375C39.6734 13.75 39.9595 13.8685 40.1705 14.0795C40.3815 14.2905 40.5 14.5766 40.5 14.875V40L35.5 36L31 40L26.5 36L22 40L17.5 36L13.5 40Z"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="27" cy="27" r="26" stroke="#154398" strokeWidth="2" />
    </svg>
  ),
  "order-step2": (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="27"
        cy="27"
        r="26"
        fill="white"
        stroke="#154398"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.871 10C32.0599 10 32.2362 10.0541 32.3851 10.1478C32.4462 10.1862 32.5032 10.2314 32.5551 10.2833L39.522 17.2502C39.7033 17.4315 39.8051 17.6773 39.8051 17.9337V24.9877C39.8051 25.5216 39.3723 25.9543 38.8384 25.9543C38.3045 25.9543 37.8718 25.5216 37.8718 24.9877V18.9002H31.871C31.3372 18.9002 30.9044 18.4674 30.9044 17.9335V11.9335H14.9333V41.9782H26.8554C27.3892 41.9782 27.8221 42.4109 27.8221 42.9448C27.8221 43.4787 27.3892 43.9114 26.8554 43.9114H13.9666C13.4328 43.9114 13 43.4787 13 42.9448V10.9669C13 10.433 13.4328 10.0001 13.9666 10.0001H31.8528L31.871 10ZM32.8377 16.9669V13.3L36.5045 16.9669H32.8377ZM20.7941 20.9378C20.2603 20.9378 19.8275 21.3706 19.8275 21.9045C19.8275 22.4384 20.2603 22.8711 20.7941 22.8711H31.3141C31.848 22.8711 32.2808 22.4384 32.2808 21.9045C32.2808 21.3706 31.848 20.9378 31.3141 20.9378H20.7941ZM16.7182 26.3633C16.7182 25.8294 17.151 25.3966 17.6849 25.3966H27.8218C28.3557 25.3966 28.7885 25.8294 28.7885 26.3633C28.7885 26.8972 28.3557 27.3299 27.8218 27.3299H17.6849C17.151 27.3299 16.7182 26.8972 16.7182 26.3633ZM18.007 29.8555C17.4731 29.8555 17.0404 30.2882 17.0404 30.8221C17.0404 31.356 17.4731 31.7887 18.007 31.7887H24.0857C24.6195 31.7887 25.0523 31.356 25.0523 30.8221C25.0523 30.2882 24.6195 29.8555 24.0857 29.8555H18.007ZM17.0404 35.2809C17.0404 34.747 17.4731 34.3143 18.007 34.3143H23.18C23.7138 34.3143 24.1466 34.747 24.1466 35.2809C24.1466 35.8148 23.7138 36.2475 23.18 36.2475H18.007C17.4731 36.2475 17.0404 35.8148 17.0404 35.2809ZM27.2644 35.0023C27.2644 31.1113 30.4186 27.957 34.3097 27.957C38.2006 27.957 41.3549 31.1113 41.3549 35.0023C41.3549 38.8933 38.2006 42.0475 34.3097 42.0475C30.4186 42.0475 27.2644 38.8933 27.2644 35.0023ZM34.3097 26.0238C29.3509 26.0238 25.331 30.0435 25.331 35.0023C25.331 39.961 29.3509 43.9809 34.3097 43.9809C39.2684 43.9809 43.2882 39.961 43.2882 35.0023C43.2882 30.0435 39.2684 26.0238 34.3097 26.0238Z"
        fill="#154398"
      />
      <path
        d="M34.2662 34.4158C36.0424 34.4158 37.4883 35.7011 37.4883 37.28C37.4883 38.61 36.4572 39.7217 35.0717 40.0421V40.7707C35.0717 41.2156 34.711 41.5762 34.2662 41.5762C33.8212 41.5762 33.4606 41.2156 33.4606 40.7707V40.0421C32.3616 39.7879 31.4857 39.036 31.1703 38.0722C31.032 37.6494 31.4046 37.28 31.8495 37.28C32.2944 37.28 32.6424 37.6706 32.8977 38.0349C33.1824 38.4411 33.6894 38.712 34.2662 38.712C35.1543 38.712 35.8772 38.0694 35.8772 37.28C35.8772 36.4905 35.1543 35.8479 34.2662 35.8479C32.49 35.8479 31.0439 34.5626 31.0439 32.9837C31.0439 31.6537 32.0751 30.542 33.4606 30.2216V29.493C33.4606 29.0482 33.8212 28.6875 34.2662 28.6875C34.711 28.6875 35.0717 29.0482 35.0717 29.493V30.2216C36.1706 30.4758 37.0466 31.2277 37.3619 32.1915C37.5003 32.6143 37.1277 32.9837 36.6828 32.9837C36.2379 32.9837 35.8899 32.5931 35.6346 32.2288C35.3499 31.8226 34.8428 31.5517 34.2662 31.5517C33.378 31.5517 32.6551 32.1943 32.6551 32.9837C32.6551 33.7732 33.378 34.4158 34.2662 34.4158Z"
        fill="#154398"
      />
    </svg>
  ),
  "order-step3": (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="27"
        cy="27"
        r="26"
        fill="white"
        stroke="#154398"
        strokeWidth="2"
      />
      <path
        d="M43.0563 37.3135H41.9677V35.7329H43.0563C43.1247 35.7329 43.18 35.6772 43.18 35.6092V29.8996C43.18 29.8696 43.169 29.8407 43.1488 29.8178L37.455 23.4131C37.4317 23.3871 37.3977 23.3716 37.3625 23.3716H32.3658V35.7329H36.8291V37.3135H30.7852V21.791H37.3625C37.8486 21.791 38.3133 21.9993 38.6365 22.3628L44.3299 28.7675C44.6073 29.0793 44.7606 29.4815 44.7606 29.8996V35.6088C44.7606 36.5489 43.996 37.3135 43.0563 37.3135Z"
        fill="#154398"
      />
      <path
        d="M32.3665 37.3134H20.6643V35.7328H30.7858V19.953C30.7858 19.007 30.2057 18.2076 29.5194 18.2076H12.0448C11.358 18.208 10.7779 19.007 10.7779 19.953V35.3009C10.7779 35.5794 10.9292 35.7328 10.9794 35.7328H15.5296V37.3134H10.9794C9.99667 37.3134 9.19727 36.4108 9.19727 35.3009V19.953C9.19727 18.1191 10.4744 16.627 12.0448 16.627H29.5194C31.0893 16.627 32.3665 18.1187 32.3665 19.953V37.3134Z"
        fill="#154398"
      />
      <path
        d="M39.3987 39.7528C37.5462 39.7528 36.0391 38.2457 36.0391 36.3928C36.0391 34.5399 37.5458 33.0332 39.3987 33.0332C41.2516 33.0332 42.7583 34.5399 42.7583 36.3928C42.7583 38.2457 41.2512 39.7528 39.3987 39.7528ZM39.3987 34.6138C38.4179 34.6138 37.6197 35.412 37.6197 36.3928C37.6197 37.374 38.4179 38.1722 39.3987 38.1722C40.3795 38.1722 41.1777 37.374 41.1777 36.3928C41.1777 35.4116 40.3795 34.6138 39.3987 34.6138Z"
        fill="#154398"
      />
      <path
        d="M18.0959 39.7528C16.2435 39.7528 14.7363 38.2457 14.7363 36.3928C14.7363 34.5399 16.2435 33.0332 18.0959 33.0332C19.9484 33.0332 21.4556 34.5399 21.4556 36.3928C21.4556 38.2457 19.9484 39.7528 18.0959 39.7528ZM18.0959 34.6138C17.1152 34.6138 16.317 35.412 16.317 36.3928C16.317 37.374 17.1152 38.1722 18.0959 38.1722C19.0767 38.1722 19.8749 37.374 19.8749 36.3928C19.8749 35.4116 19.0767 34.6138 18.0959 34.6138Z"
        fill="#154398"
      />
      <path
        d="M43.9719 30.3433H35.936C35.0493 30.3433 34.3281 29.6221 34.3281 28.7354V22.582H35.9088V28.7358L43.9719 28.7627V30.3433Z"
        fill="#154398"
      />
    </svg>
  ),
  "order-step4": (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="27"
        cy="27"
        r="26"
        fill="white"
        stroke="#154398"
        strokeWidth="2"
      />
      <path
        d="M13 26L23 35.5L40 18"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "order-step5": (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="27"
        cy="27"
        r="26"
        fill="url(#paint0_linear_1319_42017)"
        stroke="url(#paint1_linear_1319_42017)"
        strokeWidth="2"
      />
      <path
        d="M27.6203 35.8218L34.7128 40.3153C35.6194 40.8897 36.745 40.0354 36.476 38.9771L34.4268 30.9162C34.3691 30.6916 34.3759 30.4554 34.4465 30.2346C34.5171 30.0138 34.6486 29.8174 34.8258 29.668L41.1859 24.3744C42.0216 23.6788 41.5903 22.2919 40.5166 22.2222L32.2107 21.6832C31.987 21.6672 31.7724 21.588 31.592 21.4548C31.4116 21.3216 31.2727 21.1398 31.1915 20.9307L28.0938 13.1298C28.0096 12.9079 27.8598 12.7169 27.6645 12.582C27.4691 12.4472 27.2374 12.375 27 12.375C26.7626 12.375 26.5309 12.4472 26.3355 12.582C26.1402 12.7169 25.9905 12.9079 25.9062 13.1298L22.8085 20.9307C22.7273 21.1398 22.5885 21.3216 22.408 21.4548C22.2276 21.588 22.013 21.6672 21.7893 21.6832L13.4834 22.2222C12.4097 22.2919 11.9784 23.6788 12.8141 24.3744L19.1742 29.668C19.3514 29.8174 19.4829 30.0138 19.5535 30.2346C19.6241 30.4554 19.6309 30.6916 19.5732 30.9162L17.6728 38.3918C17.35 39.6617 18.7007 40.6869 19.7886 39.9976L26.3797 35.8218C26.5651 35.7038 26.7803 35.6411 27 35.6411C27.2197 35.6411 27.4349 35.7038 27.6203 35.8218V35.8218Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1319_42017"
          x1="2"
          y1="27"
          x2="52"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154398" />
          <stop offset="1" stopColor="#ED1117" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1319_42017"
          x1="2"
          y1="27"
          x2="52"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154398" />
          <stop offset="1" stopColor="#ED1117" />
        </linearGradient>
      </defs>
    </svg>
  ),
  "call-received": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0827 3.9249C15.7577 3.5999 15.2327 3.5999 14.9077 3.9249L5.83268 12.9916V8.33324C5.83268 7.8749 5.45768 7.4999 4.99935 7.4999C4.54102 7.4999 4.16602 7.8749 4.16602 8.33324V14.9999C4.16602 15.4582 4.54102 15.8332 4.99935 15.8332H11.666C12.1244 15.8332 12.4993 15.4582 12.4993 14.9999C12.4993 14.5416 12.1244 14.1666 11.666 14.1666H7.00768L16.0827 5.09157C16.3994 4.7749 16.3994 4.24157 16.0827 3.9249Z"
        fill="#0D99FF"
      />
    </svg>
  ),
}
